(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Power-featured-colleges"] && !Shopify.designMode) return;
  try {
    

  
  var collegesId= [913,917,937,1075];
  var collegesParams = collegesId.map(id => `clubIds=${id}`).join('&');
  var url = `https://api.utrsports.net/v1/club/get-info?${collegesParams}`;
  
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  }; 
  
  fetch(url, requestOptions)
    .then(response => response.json())
    .then(result => {
      let data = ""; 
  
      collegesId.forEach(id => {
        var clubInfo = result.clubInfo[id.toString()];
        var clubId = clubInfo.id;
        var name = clubInfo.name;
        var location = clubInfo.locationName;
        var memberCount = clubInfo.memberCount;
        var profilePhotoUrl = clubInfo.profilePhotoUrl;
        console.log("clubId = "+clubId);
        data += ' <div class="grid__item"><div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2 mb-sm-0"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" /></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + clubId + '" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">View site</a></div></div>   </div></div></div>';
      });
  
      // Display the combined data on the web page
      document.getElementById("college-featured").innerHTML = data;
    })
  .catch(error => console.log('error', error));
  



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-with-list-custom-zago"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
        var images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(function(img) {
            img.src = img.dataset.src;
          
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-with-list-image-left-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var images = document.querySelectorAll('img[loading="lazy"]');
  images.forEach(function(img) {
    img.src = img.dataset.src;

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-with-list-image-left"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
        var images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(function(img) {
            img.src = img.dataset.src;
          
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-academies"] && !Shopify.designMode) return;
  try {
    
var requestOptions = {
  method: 'GET',
  redirect: 'follow'
};

// Array of club IDs
var clubIds = [13210, 8890, 329, 120];

// Loop through clubIds array
clubIds.forEach((clubId, index) => {
  fetch(`https://api.utrsports.net/v1/club/get-info?clubIds=${clubId}`, requestOptions)
    .then(response => response.json())
    .then((result) => {
      let data = "";
      
      var id = result.clubInfo[clubId].id;
      var name = result.clubInfo[clubId].name;
      var location = result.clubInfo[clubId].locationName;
      var memberCount = result.clubInfo[clubId].memberCount;
      var profilePhotoUrl = result.clubInfo[clubId].profilePhotoUrl;

      data = '<div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" /></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + id + '" class="btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">View site</a></div></div>   </div></div>';

      var elementId = "academies" + (index + 1);
      document.getElementById(elementId).innerHTML = data;
    })
    .catch(error => console.log('error', error));
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-colleges"] && !Shopify.designMode) return;
  try {
    

  
  var collegesId= [913,917,937,1075];
  var collegesParams = collegesId.map(id => `clubIds=${id}`).join('&');
  var url = `https://api.utrsports.net/v1/club/get-info?${collegesParams}`;
  
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  }; 
  
  fetch(url, requestOptions)
    .then(response => response.json())
    .then(result => {
      let data = ""; 
  
      collegesId.forEach(id => {
        var clubInfo = result.clubInfo[id.toString()];
        var clubId = clubInfo.id;
        var name = clubInfo.name;
        var location = clubInfo.locationName;
        var memberCount = clubInfo.memberCount;
        var profilePhotoUrl = clubInfo.profilePhotoUrl;
        console.log("clubId = "+clubId);
        data += ' <div class="grid__item"><div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2 mb-sm-0"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" /></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + clubId + '" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">View site</a></div></div>   </div></div></div>';
      });
  
      // Display the combined data on the web page
      document.getElementById("college-featured").innerHTML = data;
    })
  .catch(error => console.log('error', error));
  



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-federations"] && !Shopify.designMode) return;
  try {
    

  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  
  //federations

  const federationId = [913, 917, 937, 1075];
  const federationParams = federationId.map(id => `clubIds=${id}`).join('&');
  const url = `https://api.utrsports.net/v1/club/get-info?${federationParams}`;

fetch(url, requestOptions)
  .then(response => response.json())
  .then(results => {
    results.forEach((result, index) => {
      const id = result.id;
      const name = result.name;
      const location = result.location.display;
      const memberCount = result.memberCount;
      const profilePhotoUrl = result.profilePhotoUrl;

      const data = `<div class="blue-teal-gradient-bg border-radius-lg-3 border-radius-sm-3">
        <div class="feature-card-box feature-card-box-small text-black d-flex justify-content-center align-items-center">
          <div>
            <div class="featureimg-medium">
              <img src="https://prod-cdn.utrsports.net/v1/club/${profilePhotoUrl}" />
            </div>
          </div>
          <div class="feature-content">
            <h4 class="fs-sm-14">${name}</h4>
            <p class="gotham-medium font-sm-9 lh-sm-normal">${location}</p>
            <div class="d-flex flex-md-col-start justify-content-between align-items-center mt-lg-2 mt-sm-0">
              <div class="number-title lh-sm-normal lh-normal">${memberCount} <span class="fs-sm-inline-flex fst-sm-12">Players</span></div>
              <a href="https://app.utrsports.net/clubs/${id}" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">VIEW FEDERATION</a>
            </div>
          </div>
        </div>
      </div>`;

      const targetElementId = `federation${index + 1}`;
      document.getElementById(targetElementId).innerHTML = data;
    });
  })
  .catch(error => console.log('error', error));
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-players-slider"] && !Shopify.designMode) return;
  try {
    
    var requestOptions = {
  method: 'GET',
  redirect: 'follow'
};

fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMax=3", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">3.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player1").innerHTML=data;

}).catch(error => console.log('error', error));

  fetch("https://api.utrsports.net/v2/search/featuredplayers?top=12&utrType=verified&utrTeamType=singles&utrMax=3", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">3.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player2").innerHTML=data;

}).catch(error => console.log('error', error));

    fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=2&utrMax=4", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">3.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player3").innerHTML=data;

}).catch(error => console.log('error', error));

  fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=3&utrMax=5", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">4.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player4").innerHTML=data;

}).catch(error => console.log('error', error));

  fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=4&utrMax=6", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">5.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player5").innerHTML=data;

}).catch(error => console.log('error', error));

  fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMax=7", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">6.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player6").innerHTML=data;

}).catch(error => console.log('error', error));

    fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=6&utrMax=8", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      var rating = values.source.singlesUtr;
        
      data +='<div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">'+rating+'</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player7").innerHTML=data;

}).catch(error => console.log('error', error));

     fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=6&utrMax=8", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      var rating = values.source.singlesUtr;
        
      data +='<div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">'+rating+'</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player8").innerHTML=data;

}).catch(error => console.log('error', error));

    fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=8&utrMax=10", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">9.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player9").innerHTML=data;

}).catch(error => console.log('error', error));

    fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=9&utrMax=11", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">10.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player10").innerHTML=data;

}).catch(error => console.log('error', error));

  fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=10&utrMax=12", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">11.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player11").innerHTML=data;

}).catch(error => console.log('error', error));

    fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=11&utrMax=13", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">12.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player12").innerHTML=data;

}).catch(error => console.log('error', error));

  fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=11&utrMax=13", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;

    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">13.0</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player13").innerHTML=data;

}).catch(error => console.log('error', error));

    fetch("https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=12", requestOptions)
  .then(response => response.json())
  .then((result) => {
    let data="";
    let i=1;
    var totalDataCount = 0;
    
    result.hits.map((values)=>{
      if(i < 7){
        
      var name = values.source.displayName;
      var location = values.source.location.display;
      var nationality= values.source.nationality;
      var rating = values.source.singlesUtr;
      
      data +=' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">'+name+'</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten">'+rating+'</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">'+location+', '+nationality+'</p></div></div></div>';
      i=i+1;
      }
    });
    
    document.getElementById("player14").innerHTML=data;

}).catch(error => console.log('error', error));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-players"] && !Shopify.designMode) return;
  try {
    
  

  

  var requestOptions = {
  method: 'GET',
  redirect: 'follow'
};

let apiUrl = `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMax=3`;
  function oldApiCalls() {
   fetch(apiUrl)
  .then(response => {
    // Check if the request was successful
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    // Parse the response body as JSON
    return response.json();
  })
  .then(data => {
    // Work with the data received from the API
    let finaldata = data.hits
    data.hits.map((data) => {
      console.log("data.hits from map method",data.id)
    })
  })
  .catch(error => {
    // Handle any errors that occurred during the fetch
    console.error('Fetch error:', error);
  });
  };
  

  let playerId = [
    3514145, 2993650, 3744084, 3734672, 3431908, 3433141,
    3338139, 3901482, 2767007, 3595433, 2671569, 3071714,
    1492977, 2683466, 2940693, 1515641, 2921430, 3432113,
    3190599, 2754212, 2658245, 1195825, 2669607, 2749240,
    1771571, 3699031, 3495152, 1594211, 3270683, 3415514,
    1552734, 2134151, 2885361, 2579636, 1913015, 3776580,
    2746465, 1367671, 529965, 2085662, 1158331, 667607,
    3868594, 836616, 1301510, 104801, 2666292, 1891817,
    1691043, 217221, 98368, 2984681, 3306157, 247560,
    288274, 226549, 1784605, 1552117, 222511, 3107591,
    11666, 1313619, 107920, 274857, 1577208, 3619361,
    92088, 2114659, 219786, 259658, 28487, 3385741,
    593241, 84281, 146056, 77574, 2554689, 64505,
    3569175, 3568338, 3554581, 3109578, 247320, 51296,
];
  let getTopUrl = [
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=1&utrMax=1`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=2&utrMax=2`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=3&utrMax=3`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=4&utrMax=4`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=5&utrMax=5`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=6&utrMax=6`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=7&utrMax=7`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=8&utrMax=8`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=9&utrMax=9`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=10&utrMax=10`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=11&utrMax=11`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=12&utrMax=12`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=13&utrMax=13`,
  `https://api.utrsports.net/v2/search/featuredplayers?top=6&utrType=verified&utrTeamType=singles&utrMin=14`,
  ];

  let batches = [];
const batchSize = 6;

for (let i = 0; i < playerId.length; i += batchSize) {
  batches.push(playerId.slice(i, i + batchSize));
}

let variables = [];
let variableCount = Math.ceil(playerId.length / batchSize);

for (let i = 0; i < variableCount; i++) {
  let variableName = `data_${i + 1}`;
  variables.push(variableName);
   // console.log(variables)
  // console.log(variableCount)
}
  // console.log(variables)
  // console.log(variableCount)

   
  
  
// Add click event handlers for "slick-next" and "slick-prev" buttons
    $(".slick-next").on("click",function(){    
    // console.log("next clicked")    
    var idValue = $(".slick-current").find(".owlnum").attr("id");
    // console.log("Element with class 'slick-current':", idValue, batches[idValue]);
      getPlayerInfo(idValue)
    
  })
    $(".slick-prev").on("click",function(){
      // console.log("next clicked")     
      var idValue = $(".slick-current").find(".owlnum").attr("id");
      // console.log("Element with class 'slick-current':", idValue, batches[idValue]);
      getPlayerInfo(idValue)
  })

  // Add click event handler for "slick-slide" elements within the element with ID "thumbs2"
	$("#thumbs2 .slick-slide").on("click",function(){
		let index=$(this).attr("data-slick-index");
        let idValue = $(this).find(".owlnum").attr("id");
		$("#slider").slick("slickGoTo",index);
      // console.log(idValue, batches[idValue])
      getPlayerInfo(idValue)
	})

         // Function to handle the initial loading
        function initialLoad() {
            var idValue = $(".slick-current").find(".owlnum").attr("id");
           
            getPlayerInfo(idValue);
        };

        // Call the initialLoad function on page load
        $(document).ready(function() {
            initialLoad();
          oldApiCalls();
          // console.log("init loaded")
        });

  // Function to fetch player information from the API
  function getPlayerInfo(idValue) {    
    let playerIdsNew= []
    // console.log(idValue)
     if(idValue == "0") {
       idValue = 0
     }

    fetch(getTopUrl[idValue])
  .then(response => {
    // Check if the request was successful
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    // Parse the response body as JSON
    return response.json();
  })
    .then(data => {
    // Work with the data received from the API
    let finaldata = data.hits;
    data.hits.map(data => {
      playerIdsNew.push(Number(data.id));
    });

    // Convert playerIdsNew array to a string with "&playerIds=" separator
    let playerIds = playerIdsNew.join('&playerIds=');  
   
        
   let url = `https://api.utrsports.net/v1/player/get-info?playerIds=${playerIds}`;

      fetch(url, requestOptions)
     .then(response => response.json())
     .then((result) => {
       let data = "";
       let i = 1;
       var totalDataCount = 0;

       Object.values(result.playerInfo).forEach((player) => {
         var playerId = player.id
         var name = player.name;
         var location = player.location;
         var ratings = player.rating;      

         data += ' <div class="grid__item"><div class="blue-teal-gradient-bg card-brieg shadow-xl"> <a href=https://app.utrsports.net/profiles/'+ playerId +' class="full-unstyled-link"> <div class="p-2 text-black lh-normal"><div class="d-flex justify-content-between align-items-center"> <div> <div class="brige text-black gotham-medium">' + name + '</div> <div class="brige text-black fw-bold"></div> </div> <div> <div class="brige-price text-black fw-bold font-tungsten-medium">' + Number(ratings).toFixed(2) + '</div> <div class="utr text-mute lh-normal fw-bold text-sm-center gotham-medium">UTR</div> </div> </div> <p class="text-mute pt-2 mb-0 fw-bold font-lg-16 font-sm-13">' + location + '</p></div></a></div></div>';
         i++;
       
       });          
       let outputElement = document.getElementById(`player${Number(idValue) + 1}`);       
      if (outputElement) {
        outputElement.innerHTML = data;
      }      
    })
      
  })
      
  .catch(error => {
    // Handle any errors that occurred during the fetch
    console.error('Fetch error:', error);
  });

//     console.log("playerIdsNew playerIdsNew", playerIdsNew, batches[idValue])   
    
//     console.log(`apiUrl as come from onclick of numbers ${idValue}`, getTopUrl[idValue])
    
    
   
// console.log(url)
//     console.log("playerIdsplayerIdsplayerIdsplayerIds",playerIds)
    
   
  }
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-providers-accordion"] && !Shopify.designMode) return;
  try {
    
  
  var requestOptions = {
  method: 'GET',
  redirect: 'follow'
};

  //club
  var clubsIds = [9495, 80, 75, 7016];
  var highSchoolsIds = [6370, 6144, 12211, 3697];
  var collegesIds =[913,938,920,915];
  var academiesIds = [13210,8890,329,120];
  const allClubIds = clubsIds.concat(highSchoolsIds, collegesIds,academiesIds); 
  
  var clubParams = clubsIds.map(id => `clubIds=${id}`).join('&'); 
  var highSchoolParams = highSchoolsIds.map(id => `clubIds=${id}`).join('&'); 
  var collegesParams = collegesIds.map(id => `clubIds=${id}`).join('&'); 
  var academiesParams = academiesIds.map(id => `clubIds=${id}`).join('&'); 
  var allProviderParams = clubParams + '&' + highSchoolParams + '&' + collegesParams + '&' + academiesParams;
  var fetchProviderUrl = `https://api.utrsports.net/v1/club/get-info?${allProviderParams}`;

  var url = `https://api.utrsports.net/v1/club/get-info?${clubParams}`;

  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  fetch(fetchProviderUrl, requestOptions)
    .then(response => response.json())
    .then(result => { 
      let clubData = "";
      let highSchooldata = "";
      let collegeData = "";
      let academiesData = "";
  
      allClubIds.forEach(id => {
        var clubInfo = result.clubInfo[id.toString()];
        var clubId = clubInfo.id;
        var name = clubInfo.name;
        var location = clubInfo.locationName;
        var memberCount = clubInfo.memberCount;
        var profilePhotoUrl = clubInfo.profilePhotoUrl;

        if (clubsIds.includes(clubId,0)) {
          clubData += ' <div class="grid__item"><div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2 mb-sm-0"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" loading="lazy" width="100" height="100" alt="clubs-img"/></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + clubId + '" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">View site</a></div></div>   </div></div></div>';  
        } 

        if (highSchoolsIds.includes(clubId,0)) {
          highSchooldata += ' <div class="grid__item"><div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2 mb-sm-0"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" loading="lazy" width="100" height="100" alt="high-school-img"/></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + clubId + '" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">View site</a></div></div>   </div></div></div>';
        } 

        if (collegesIds.includes(clubId,0)) {
          collegeData += ' <div class="grid__item"><div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2 mb-sm-0"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" loading="lazy" width="100" height="100" alt="college-img"/></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + clubId + '" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">View site</a></div></div>   </div></div></div>';
        } 

        if (academiesIds.includes(clubId,0)) {
          academiesData += ' <div class="grid__item"><div class="blue-teal-gradient-bg min-h-100 border-radius-lg-3 border-radius-sm-3 mb-2 mb-sm-0"><div class="feature-card-box text-black d-flex justify-content-center align-items-center"><div><div class="featureimg-medium"><img src="https://prod-cdn.utrsports.net/v1/club/' + profilePhotoUrl + '" loading="lazy" width="100" height="100" alt="academies-img"/></div></div>  <div class="feature-content"><h4>' + name + '</h4><p>' + location + '</p><div class="d-flex justify-content-between align-items-end"><div class="number-title">' + memberCount + ' <span>Players</span></div><a href="https://app.utrsports.net/clubs/' + clubId + '" class="btn-black btn-outline-black min-w-160 btn-xs-1 btn-xs-0 min-w-sm-100-px font-lg-16 font-sm-10 text-uppercase">View site</a></div></div>   </div></div></div>';
        }
        
      });
  
      // Display the combined data on the web page
      document.getElementById("clubs").innerHTML = clubData;
      document.getElementById("high_school").innerHTML = highSchooldata;
      document.getElementById("college").innerHTML = collegeData;      
      document.getElementById("academies").innerHTML = academiesData;

    });

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flex-leagues-for-everyone"] && !Shopify.designMode) return;
  try {
    


  let markerLocations = [];
  let eventLocations = [];
  let map;
  
  function setMarkers() {
    
    var infoWindow;
    
    for (var i = 0; i < eventLocations.length; i++) {
      var event = eventLocations[i];
      var myLatLng = new google.maps.LatLng(event[0], event[1]);
      const pinIcon = "https://cdn.shopify.com/s/files/1/0690/8071/1488/files/location-vector.svg?v=1679692179";
      // Create an info window to share between markers.
      infoWindow = new google.maps.InfoWindow();
      
      var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          icon: pinIcon,
          animation: google.maps.Animation.DROP,
          title: event[2],
          zIndex: event[3],
          optimized: true
      });

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          var contentString = '<div><a href="https://api.utrsports.net/clubs/'+eventLocations[i][4]+'" target="_blank">'+marker.getTitle()+'</div>';
          infoWindow.close();
          infoWindow.setContent(contentString);
          infoWindow.open(map, marker);
          for(var j = 0; j < markerLocations.length; j++) {
            //markerLocations[j].
          }
        }
    
      })(marker, i)); 
      
      // Push marker to markers array
      markerLocations.push(marker);
      
      map.setZoom(4);
      map.panTo(marker.position);

    }
    
  }

  function reloadMarkers() {

    // Loop through markers and set map to null for each
    for (var i=0; i<markerLocations.length; i++) {

        markerLocations[i].setMap(null);
        markerLocations[i] = null;
    }

    // Reset the markers array
    markerLocations = [];

    // Call set markers to re-add markers
    setMarkers();

  }

  window.initializeMap = function(){
    var mapOptions = {
       zoom: 4,
       center: { lat: 34.84555, lng: -101.299591 }
    }

    map = new google.maps.Map(document.getElementById('map'), mapOptions);
    
    setMarkers();

    // Bind event listener on button to reload markers
    //document.getElementById('reloadMarkers').addEventListener('click', reloadMarkers);

  }

  var clubData = {
    clubIds: []
  };

  var searchText = "";
  var distanceText = "";
  
  //Search Functionality
  let searchBtn = document.querySelector('.club-search-btn');
  searchBtn.onclick = () => {
    searchText = document.getElementById('search_input').value;
    distanceText = document.getElementById('distance_input').value;
    fetchDataFromGoogleMapAPI(searchText);
  }

  $('#search_input').keypress(function (e) {
   console.log('input');
    if (e.which == 13) {

      e.preventDefault();
     
      //do something
      searchText = document.getElementById('search_input').value;
      distanceText = document.getElementById('distance_input').value;
      fetchDataFromGoogleMapAPI(searchText);
  
   }
  });


  //Fetch initial club data
  fetchClubs("https://api.utrsports.net/v2/search/clubs/13?top=500&skip=0");
  var distence_msg = document.getElementById("updating-msg");
  
  function fetchClubs(fetchURL) {
    console.log("fetchClubs");

    eventLocations = [];
    clubData.clubIds = [];
    
    //Fetch league for everyone data
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
    var cCount = 0;
    fetch(fetchURL, requestOptions)
      .then(response => response.json())
      .then((result) => {
        let data="";
         let tennisWinnerData = [];

        result.hits.map((values)=>{
            tennisWinnerData.push(values);          
        });
        
        //document.getElementById("flex").innerHTML="";
        if (tennisWinnerData.length > 0) {
        tennisWinnerData.forEach((values) =>{
           var clubName = values.source.name;  
          if (!clubName.includes('Pickleball')) {
          var id = values.source.id;
          var member = values.source.memberCount;    
          var startDate = "";
          var eventName = "";
          var llat = values.source.location.latLng[0];
          var llng = values.source.location.latLng[1];
          data += '<div class="item">' + 
'    <div class="search-item-data pe-lg-6 border-radius-lg-18 border-radius-sm-3 text-black p-2 position-relative">' + 
'        <div class="d-flex align-items-center justify-content-between"><h3 class="mb-2 flex-text-ellipsis mt-0 fw-bold text-uppercase lh-normal"><a href="https://app.utrsports.net/clubs/'+id+'" target="_blank">'+clubName+'</a></h3></div>' +
'        <div class="d-flex align-items-center justify-content-start flex-sm-column align-items-sm-start justify-content-sm-start">' + 
'            <h4 class="d-flex align-items-lg-center justify-content-lg-center gap-1 mb-0 mt-0">' + 
'                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'                    <path d="M3.26133 4.24336C3.26133 3.36814 3.60901 2.52878 4.22788 1.90991C4.84675 1.29104 5.68611 0.943359 6.56133 0.943359C7.43654 0.943359 8.27591 1.29104 8.89478 1.90991C9.51365 2.52878 9.86133 3.36814 9.86133 4.24336C9.86133 5.11857 9.51365 5.95794 8.89478 6.57681C8.27591 7.19568 7.43654 7.54336 6.56133 7.54336C5.68611 7.54336 4.84675 7.19568 4.22788 6.57681C3.60901 5.95794 3.26133 5.11857 3.26133 4.24336ZM11.0613 6.04336C11.0613 5.68879 11.1312 5.33769 11.2669 5.01011C11.4025 4.68253 11.6014 4.38489 11.8521 4.13417C12.1029 3.88345 12.4005 3.68457 12.7281 3.54888C13.0557 3.4132 13.4068 3.34336 13.7613 3.34336C14.1159 3.34336 14.467 3.4132 14.7946 3.54888C15.1222 3.68457 15.4198 3.88345 15.6705 4.13417C15.9212 4.38489 16.1201 4.68253 16.2558 5.01011C16.3915 5.33769 16.4613 5.68879 16.4613 6.04336C16.4613 6.75944 16.1769 7.4462 15.6705 7.95255C15.1642 8.4589 14.4774 8.74336 13.7613 8.74336C13.0452 8.74336 12.3585 8.4589 11.8521 7.95255C11.3458 7.4462 11.0613 6.75944 11.0613 6.04336ZM0.861328 14.4434C0.861328 12.9316 1.46186 11.4818 2.53082 10.4129C3.59978 9.34389 5.04959 8.74336 6.56133 8.74336C8.07306 8.74336 9.52288 9.34389 10.5918 10.4129C11.6608 11.4818 12.2613 12.9316 12.2613 14.4434V14.4458L12.2605 14.541C12.2588 14.6427 12.2313 14.7423 12.1805 14.8305C12.1297 14.9187 12.0573 14.9925 11.9701 15.045C10.3375 16.0281 8.46714 16.5463 6.56133 16.5434C4.58373 16.5434 2.73253 15.9962 1.15333 15.045C1.06601 14.9926 0.993462 14.9188 0.942517 14.8306C0.891573 14.7425 0.863908 14.6428 0.862128 14.541L0.861328 14.4434ZM13.4613 14.4458L13.4605 14.561C13.4561 14.8276 13.3924 15.0899 13.2741 15.329C14.6707 15.4151 16.0657 15.1367 17.3221 14.521C17.4193 14.4735 17.5018 14.4006 17.561 14.31C17.6201 14.2195 17.6537 14.1146 17.6581 14.0066C17.6864 13.3356 17.5408 12.6686 17.2357 12.0704C16.9305 11.4721 16.476 10.9628 15.9162 10.5918C15.3564 10.2207 14.7102 10.0005 14.0403 9.95254C13.3705 9.90454 12.6995 10.0303 12.0925 10.3178C12.9831 11.5086 13.4631 12.9563 13.4605 14.4434V14.4458H13.4613Z" fill="black"></path>' + 
'                </svg>' + 
'                <span class="fw-bold font-lg-18">'+member+'</span>' + 
'            </h4>' + 
'            <div id="flexEventStartDate_'+id+'"></div>' + 
'        </div>' + 
'        <div id="flexEventName_'+id+'"></div>' + 
'    </div>' + 
'</div>';
          clubData.clubIds.push(id);
          eventLocations.push([llat,llng,clubName,cCount,id]);
          cCount+=1;
          elseCounter = 0;

          if (elseCounter == 0){
          distence_msg.innerHTML = ' ';
        }
          }
        });
            map.setZoom(6);
        } else {
         elseCounter++;
        console.log("elseCounter", elseCounter);
        if (elseCounter == 0){
          distence_msg.innerHTML = '';
        }
        if (elseCounter <= 1) {
          var searchText = document.getElementById('search_input').value;
          var setinInputBox = document.getElementById('distance_input');
          setinInputBox.value = '250';
          distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + distanceText + ' miles - displaying results within 250 miles</h3>';

          distanceText = '250';
          setTimeout(function () {
            fetchDataFromGoogleMapAPI(searchText);
          }, 1000);
        } else if (elseCounter <= 2) {
          var searchText = document.getElementById('search_input').value;
          var setinInputBox = document.getElementById('distance_input');
          setinInputBox.value = '500';
          distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + distanceText + ' miles - displaying results within 500 miles</h3>';
          distanceText = '500';

          setTimeout(function () {
            fetchDataFromGoogleMapAPI(searchText);
          }, 1000);
        } else {
          var setinInputBox = document.getElementById('distance_input');
          distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + setinInputBox.value + ' miles </h3>';
          elseCounter = 0;
          distanceText = '100';
        }
      }
        
        var element_flex = document.getElementById("flex");

        if (element_flex) {
          element_flex.innerHTML=data;
          if (data) {
            fetchEventsData(); 
          }
        }

        reloadMarkers();
        
      }).catch(error => console.log('error', error));

  }



  
  
  //Fetch Events for Clubs
  function fetchEventsData(){
    console.log("fetchEventsData");
    const fetchURL = "https://api.utrsports.net/v1/events/latest";
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(clubData),
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.json())
      .then((result) => {
        
        result.hits.map((values)=>{
        
          var eventId = values.source.id;
          var eventName = values.source.name;
          var clubId = values.source.club.id;
          var eventStartShort = values.source.eventSchedule.eventStartShort;

          var element_eventStartDate = document.getElementById('flexEventStartDate_'+clubId);
          var element_eventName = document.getElementById('flexEventName_'+clubId);
          if (element_eventStartDate) {
            element_eventStartDate.innerHTML='<p class="font-lg-14 font-sm-12 mb-0 mt-0 px-lg-2 d-sm-block">Register Now for '+eventStartShort+' Session</p>';
          }
          if (element_eventName) {
            element_eventName.innerHTML='<p class="font-lg-14 font-sm-12 mb-0 pb-sm-4"><span class="text-decoration-underline d-sm-block"><a href="https://api.utrsports.net/events/'+eventId+'" target="_blank">'+eventName+'</a></span></p>';          
          }
        });
      }).catch(error => console.log('error', error));
  }

  function fetchDataFromGoogleMapAPI(region){
    console.log("fetchDataFromGoogleMapAPI");

    if (!region) {
      fetchClubs("https://api.utrsports.net/v2/search/clubs/13");
    } else {
          const fetchURL = 'https://maps.googleapis.com/maps/api/geocode/json?address='+region+'&key=AIzaSyCapzh9VsfXAzC9fAaosZJulONx7H1BFaY&language=en';
    let latVal = "";
    let longVal = "";
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.text())
      .then((data) => {
        let result = JSON.parse(data);
        if (result.results.length > 0) {
          console.log(result.results);
          latVal = result.results[0].geometry.location.lat;
          longVal = result.results[0].geometry.location.lng;
          console.log("geo loc data",distanceText, ' ',latVal, ' ',longVal   );
          if (latVal && longVal) {
             fetchClubs('https://api.utrsports.net/v2/search/clubs/13?distance='+distanceText+'mi&pin='+latVal+','+longVal);
          }          
        }
      })
      .catch(error => console.log('error', error));      
    }    
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flex-leagues-pickleball"] && !Shopify.designMode) return;
  try {
    



  let markerLocations = [];
  let eventLocations = [];
  let map;

   let elseCounter = 0;
  
  function setMarkers() {
    
    var infoWindow;
    
    for (var i = 0; i < eventLocations.length; i++) {
      var event = eventLocations[i];
      var myLatLng = new google.maps.LatLng(event[0], event[1]);
      const pinIcon = "https://cdn.shopify.com/s/files/1/0690/8071/1488/files/location-vector.svg?v=1679692179";
      // Create an info window to share between markers.
      infoWindow = new google.maps.InfoWindow();
      
      var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          icon: pinIcon,
          animation: google.maps.Animation.DROP,
          title: event[2],
          zIndex: event[3],
          optimized: true
      });

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          var contentString = '<div><a href="https://app.utrsports.net/clubs/'+eventLocations[i][4]+'" target="_blank">'+marker.getTitle()+'</div>';
          infoWindow.close();
          infoWindow.setContent(contentString);
          infoWindow.open(map, marker);
          for(var j = 0; j < markerLocations.length; j++) {
            //markerLocations[j].
          }
        }
    
      })(marker, i)); 
      
      // Push marker to markers array
      markerLocations.push(marker);
      
      map.setZoom(4);
      map.panTo(marker.position);

    }
    
  }

  function reloadMarkers() {

    // Loop through markers and set map to null for each
    for (var i=0; i<markerLocations.length; i++) {

        markerLocations[i].setMap(null);
        markerLocations[i] = null;
    }

    // Reset the markers array   
    markerLocations = [];

    // Call set markers to re-add markers
    setMarkers();

  }

  window.initializeMap = function(){
    var mapOptions = {
       zoom: 4,
       center: { lat: 34.84555, lng: -101.299591 }
    }

    map = new google.maps.Map(document.getElementById('map'), mapOptions);
    
    setMarkers();

    // Bind event listener on button to reload markers
    //document.getElementById('reloadMarkers').addEventListener('click', reloadMarkers);

  }

  var clubData = {
    clubIds: []
  };

  var searchText = "";
  var distanceText = "";
  
  //Search Functionality
  let searchBtn = document.querySelector('.club-search-btn');
  searchBtn.onclick = () => {
    searchText = document.getElementById('search_input').value;
    distanceText = document.getElementById('distance_input').value;
    fetchDataFromGoogleMapAPI(searchText);
  }

  $('#search_input').keypress(function (e) {                                
 
    if (e.which == 13) {

      e.preventDefault();     
     
      //do something     
      searchText = document.getElementById('search_input').value;
      distanceText = document.getElementById('distance_input').value;
      fetchDataFromGoogleMapAPI(searchText);  
       elseCounter = 0;
   }
   
    
  }); 


  //Fetch initial club data
  fetchClubs("https://api.utrsports.net/v2/search/clubs/13?top=500&skip=0");
 
   var distence_msg = document.getElementById("updating-msg");
 function fetchClubs(fetchURL) {
    eventLocations = [];
  clubData.clubIds = [];

  //Fetch league for Pickleball data
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  var cCount = 0;

  fetch(fetchURL, requestOptions)
    .then(response => response.json())
    .then((result) => {
      let data = "";
      let pickleData = []; // Array to hold data of clubs containing "Pickleball"
      

      result.hits.forEach((values) => {
        var clubName = values.source.name;
        if (clubName.includes('Pickleball')) {
          pickleData.push(values); // Push club data to pickleData array
        }
      });

      if (pickleData.length > 0) {
       
        pickleData.forEach((values) => {
        

          var id = values.source.id;
          var member = values.source.memberCount;
          var llat = values.source.location.latLng[0];
          var llng = values.source.location.latLng[1];
          data +=
            '<div class="item"><div class="search-item-data pe-lg-6 border-radius-lg-18 border-radius-sm-3 text-black p-2 position-relative"><div class="d-flex align-items-center justify-content-between"><h3 class="mb-2 flex-text-ellipsis mt-0 fw-bold text-uppercase lh-normal custom-margin-bottom">' +
            values.source.name +
            '</h3></div><div class="d-flex align-items-center justify-content-start flex-sm-column align-items-sm-start justify-content-sm-start"><h4 class="d-flex align-items-lg-center justify-content-lg-center gap-1 mb-0 mt-0"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.26133 4.24336C3.26133 3.36814 3.60901 2.52878 4.22788 1.90991C4.84675 1.29104 5.68611 0.943359 6.56133 0.943359C7.43654 0.943359 8.27591 1.29104 8.89478 1.90991C9.51365 2.52878 9.86133 3.36814 9.86133 4.24336C9.86133 5.11857 9.51365 5.95794 8.89478 6.57681C8.27591 7.19568 7.43654 7.54336 6.56133 7.54336C5.68611 7.54336 4.84675 7.19568 4.22788 6.57681C3.60901 5.95794 3.26133 5.11857 3.26133 4.24336ZM11.0613 6.04336C11.0613 5.68879 11.1312 5.33769 11.2669 5.01011C11.4025 4.68253 11.6014 4.38489 11.8521 4.13417C12.1029 3.88345 12.4005 3.68457 12.7281 3.54888C13.0557 3.4132 13.4068 3.34336 13.7613 3.34336C14.1159 3.34336 14.467 3.4132 14.7946 3.54888C15.1222 3.68457 15.4198 3.88345 15.6705 4.13417C15.9212 4.38489 16.1201 4.68253 16.2558 5.01011C16.3915 5.33769 16.4613 5.68879 16.4613 6.04336C16.4613 6.75944 16.1769 7.4462 15.6705 7.95255C15.1642 8.4589 14.4774 8.74336 13.7613 8.74336C13.0452 8.74336 12.3585 8.4589 11.8521 7.95255C11.3458 7.4462 11.0613 6.75944 11.0613 6.04336ZM0.861328 14.4434C0.861328 12.9316 1.46186 11.4818 2.53082 10.4129C3.59978 9.34389 5.04959 8.74336 6.56133 8.74336C8.07306 8.74336 9.52288 9.34389 10.5918 10.4129C11.6608 11.4818 12.2613 12.9316 12.2613 14.4434V14.4458L12.2605 14.541C12.2588 14.6427 12.2313 14.7423 12.1805 14.8305C12.1297 14.9187 12.0573 14.9925 11.9701 15.045C10.3375 16.0281 8.46714 16.5463 6.56133 16.5434C4.58373 16.5434 2.73253 15.9962 1.15333 15.045C1.06601 14.9926 0.993462 14.9188 0.942517 14.8306C0.891573 14.7425 0.863908 14.6428 0.862128 14.541L0.861328 14.4434ZM13.4613 14.4458L13.4605 14.561C13.4561 14.8276 13.3924 15.0899 13.2741 15.329C14.6707 15.4151 16.0657 15.1367 17.3221 14.521C17.4193 14.4735 17.5018 14.4006 17.561 14.31C17.6201 14.2195 17.6537 14.1146 17.6581 14.0066C17.6864 13.3356 17.5408 12.6686 17.2357 12.0704C16.9305 11.4721 16.476 10.9628 15.9162 10.5918C15.3564 10.2207 14.7102 10.0005 14.0403 9.95254C13.3705 9.90454 12.6995 10.0303 12.0925 10.3178C12.9831 11.5086 13.4631 12.9563 13.4605 14.4434V14.4458H13.4613Z" fill="black"></path></svg><span class="fw-bold font-lg-18">' +
            member +
            '</span></h4><div id="flexEventStartDate_' + id + '"></div></div><div id="flexEventName_' + id + '"></div><div class="rwbtn-lg mt-sm-0 d-sm-flex justify-content-sm-end custom-position-button"><a target="_blank" href="https://app.utrsports.net/clubs/' + '' + id + '" class="btn-black-sm btn-outline-black text-uppercase font-sm-14">REGISTER NOW</a></div></div></div>';
          clubData.clubIds.push(id);
          eventLocations.push([llat, llng, values.source.name, cCount, id]); // Use club name from 'values'
          cCount += 1;
          elseCounter = 0;
          

          if (elseCounter == 0){
          distence_msg.innerHTML = ' ';
        }
          
        });
        console.log("elseCounter", elseCounter);
      } else {
        elseCounter++;
       console.log("elseCounter", elseCounter);
        if (elseCounter == 0){
          distence_msg.innerHTML = '';
        }
        if (elseCounter <= 1) {
          var searchText = document.getElementById('search_input').value;
          var setinInputBox = document.getElementById('distance_input');
          setinInputBox.value = '250';
          distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + distanceText + ' miles - displaying results within 250 miles</h3>';

          distanceText = '250';
          setTimeout(function () {
            fetchDataFromGoogleMapAPI(searchText);
          }, 1000);
        } else if (elseCounter <= 2) {
          
          var searchText = document.getElementById('search_input').value;
          var setinInputBox = document.getElementById('distance_input');
          setinInputBox.value = '500';
          distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + distanceText + ' miles - displaying results within 500 miles</h3>';
          distanceText = '500'; 

          setTimeout(function () {
            fetchDataFromGoogleMapAPI(searchText);
          }, 1000);
        } else {
          var setinInputBox = document.getElementById('distance_input');
          distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + setinInputBox.value + ' miles </h3>';
          elseCounter = 0;
          distanceText = '100';         
        }

      }
      var element_flex = document.getElementById("flex");
     
      
      if (element_flex) {
        element_flex.innerHTML = data;
        if (data) {
          fetchEventsData();
        }
      }

      reloadMarkers();

    }).catch(error => console.log('error', error));

}


  
  //Fetch Events for Clubs
  function fetchEventsData(){
    
    const fetchURL = "https://api.utrsports.net/v1/events/latest";
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(clubData),
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.json())
      .then((result) => {
        
        result.hits.map((values)=>{
        
          var eventId = values.source.id;
          var eventName = values.source.name;  
          var clubId = values.source.club.id;
          var eventStartShort = values.source.eventSchedule.eventStartShort;

          var element_eventStartDate = document.getElementById('flexEventStartDate_'+clubId);
          var element_eventName = document.getElementById('flexEventName_'+clubId);
          if (element_eventStartDate) {
            element_eventStartDate.innerHTML='<p class="font-lg-14 font-sm-12 mb-0 mt-0 px-lg-2 d-sm-block">Register Now for '+eventStartShort+' Session</p>';
          }
          if (element_eventName) {
            element_eventName.innerHTML='<p class="font-lg-14 font-sm-12 mb-0 pb-sm-4"><span class="text-decoration-underline d-sm-block">'+eventName+'</span></p>';          
          }
        });
      }).catch(error => console.log('error', error));          
  }

  function fetchDataFromGoogleMapAPI(region){
    

    if (!region) {
      fetchClubs("https://api.utrsports.net/v2/search/clubs/13");
    } else {
          const fetchURL = 'https://maps.googleapis.com/maps/api/geocode/json?address='+region+'&key=AIzaSyCapzh9VsfXAzC9fAaosZJulONx7H1BFaY&language=en';
    let latVal = "";
    let longVal = "";
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.text())
      .then((data) => {
        let result = JSON.parse(data);
       
        if (result.results.length > 0) {
          
          latVal = result.results[0].geometry.location.lat;
          longVal = result.results[0].geometry.location.lng;
          if (latVal && longVal) {
             fetchClubs('https://api.utrsports.net/v2/search/clubs/13?distance='+distanceText+'mi&pin='+latVal+','+longVal);
          }          
        }
      })
      .catch(error => console.log('error', error));      
    }    
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flex-leagues-tennis"] && !Shopify.designMode) return;
  try {
    


  let markerLocations = [];
  let eventLocations = [];
  let map;
  
  function setMarkers() {
    
    var infoWindow;
    
    for (var i = 0; i < eventLocations.length; i++) {
      var event = eventLocations[i];
      var myLatLng = new google.maps.LatLng(event[0], event[1]);
      const pinIcon = "https://cdn.shopify.com/s/files/1/0690/8071/1488/files/location-vector.svg?v=1679692179";
      // Create an info window to share between markers.
      infoWindow = new google.maps.InfoWindow();
      
      var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          icon: pinIcon,
          animation: google.maps.Animation.DROP,
          title: event[2],
          zIndex: event[3],
          optimized: true
      });

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          var contentString = '<div><a href="https://app.utrsports.net/clubs/'+eventLocations[i][4]+'" target="_blank">'+marker.getTitle()+'</div>';
          infoWindow.close();
          infoWindow.setContent(contentString);
          infoWindow.open(map, marker);
          for(var j = 0; j < markerLocations.length; j++) {
            //markerLocations[j].
          }
        }
    
      })(marker, i)); 
      
      // Push marker to markers array
      markerLocations.push(marker);
      
      map.setZoom(4);
      map.panTo(marker.position);

    }
    
  }

  function reloadMarkers() {

    // Loop through markers and set map to null for each
    for (var i=0; i<markerLocations.length; i++) {

        markerLocations[i].setMap(null);
        markerLocations[i] = null;
    }

    // Reset the markers array
    markerLocations = [];

    // Call set markers to re-add markers
    setMarkers();

  }

  window.initializeMap = function(){
    var mapOptions = {
       zoom: 4,
       center: { lat: 34.84555, lng: -101.299591 }
    }

    map = new google.maps.Map(document.getElementById('map'), mapOptions);
    
    setMarkers();

    // Bind event listener on button to reload markers
    //document.getElementById('reloadMarkers').addEventListener('click', reloadMarkers);

  }

  var clubData = {
    clubIds: []
  };

  var searchText = "";
  var distanceText = "";
  
  //Search Functionality
  let searchBtn = document.querySelector('.club-search-btn');
  searchBtn.onclick = () => {
    searchText = document.getElementById('search_input').value;
    distanceText = document.getElementById('distance_input').value;
    fetchDataFromGoogleMapAPI(searchText);
  }

  $('#search_input').keypress(function (e) {                                
   console.log('input');
    if (e.which == 13) {

      e.preventDefault();     
     
      //do something     
      searchText = document.getElementById('search_input').value;
      distanceText = document.getElementById('distance_input').value;
      fetchDataFromGoogleMapAPI(searchText);
  
   }
  }); 


  //Fetch initial club data
  fetchClubs("https://api.utrsports.net/v2/search/clubs/13?top=500&skip=0");
  
  function fetchClubs(fetchURL) {  
    console.log("fetchClubs");

    eventLocations = [];
    clubData.clubIds = [];
    
    //Fetch league for Tennis data
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
    var cCount = 0;
    fetch(fetchURL, requestOptions)
      .then(response => response.json())
      .then((result) => {
        let data="";
        //document.getElementById("flex").innerHTML="";
        result.hits.map((values)=>{
          var clubName = values.source.name;  
          if (!clubName.includes('Pickleball')) {
            console.log('Club Name = '+clubName);
            var id = values.source.id;
            var member = values.source.memberCount;    
            var startDate = "";
            var eventName = "";
            var llat = values.source.location.latLng[0];
            var llng = values.source.location.latLng[1];
            data +='<div class="item"><div class="search-item-data pe-lg-6 border-radius-lg-18 border-radius-sm-3 text-black p-2 position-relative"><div class="d-flex align-items-center justify-content-between"><h3 class="mb-2 flex-text-ellipsis mt-0 fw-bold text-uppercase lh-normal">'+clubName+'</h3></div><div class="d-flex align-items-center justify-content-start flex-sm-column align-items-sm-start justify-content-sm-start"><h4 class="d-flex align-items-lg-center justify-content-lg-center gap-1 mb-0 mt-0"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.26133 4.24336C3.26133 3.36814 3.60901 2.52878 4.22788 1.90991C4.84675 1.29104 5.68611 0.943359 6.56133 0.943359C7.43654 0.943359 8.27591 1.29104 8.89478 1.90991C9.51365 2.52878 9.86133 3.36814 9.86133 4.24336C9.86133 5.11857 9.51365 5.95794 8.89478 6.57681C8.27591 7.19568 7.43654 7.54336 6.56133 7.54336C5.68611 7.54336 4.84675 7.19568 4.22788 6.57681C3.60901 5.95794 3.26133 5.11857 3.26133 4.24336ZM11.0613 6.04336C11.0613 5.68879 11.1312 5.33769 11.2669 5.01011C11.4025 4.68253 11.6014 4.38489 11.8521 4.13417C12.1029 3.88345 12.4005 3.68457 12.7281 3.54888C13.0557 3.4132 13.4068 3.34336 13.7613 3.34336C14.1159 3.34336 14.467 3.4132 14.7946 3.54888C15.1222 3.68457 15.4198 3.88345 15.6705 4.13417C15.9212 4.38489 16.1201 4.68253 16.2558 5.01011C16.3915 5.33769 16.4613 5.68879 16.4613 6.04336C16.4613 6.75944 16.1769 7.4462 15.6705 7.95255C15.1642 8.4589 14.4774 8.74336 13.7613 8.74336C13.0452 8.74336 12.3585 8.4589 11.8521 7.95255C11.3458 7.4462 11.0613 6.75944 11.0613 6.04336ZM0.861328 14.4434C0.861328 12.9316 1.46186 11.4818 2.53082 10.4129C3.59978 9.34389 5.04959 8.74336 6.56133 8.74336C8.07306 8.74336 9.52288 9.34389 10.5918 10.4129C11.6608 11.4818 12.2613 12.9316 12.2613 14.4434V14.4458L12.2605 14.541C12.2588 14.6427 12.2313 14.7423 12.1805 14.8305C12.1297 14.9187 12.0573 14.9925 11.9701 15.045C10.3375 16.0281 8.46714 16.5463 6.56133 16.5434C4.58373 16.5434 2.73253 15.9962 1.15333 15.045C1.06601 14.9926 0.993462 14.9188 0.942517 14.8306C0.891573 14.7425 0.863908 14.6428 0.862128 14.541L0.861328 14.4434ZM13.4613 14.4458L13.4605 14.561C13.4561 14.8276 13.3924 15.0899 13.2741 15.329C14.6707 15.4151 16.0657 15.1367 17.3221 14.521C17.4193 14.4735 17.5018 14.4006 17.561 14.31C17.6201 14.2195 17.6537 14.1146 17.6581 14.0066C17.6864 13.3356 17.5408 12.6686 17.2357 12.0704C16.9305 11.4721 16.476 10.9628 15.9162 10.5918C15.3564 10.2207 14.7102 10.0005 14.0403 9.95254C13.3705 9.90454 12.6995 10.0303 12.0925 10.3178C12.9831 11.5086 13.4631 12.9563 13.4605 14.4434V14.4458H13.4613Z" fill="black"></path></svg><span class="fw-bold font-lg-18">'+member+'</span></h4><div id="flexEventStartDate_'+id+'"></div></div><div id="flexEventName_'+id+'"></div><div class="rwbtn-lg mt-sm-0 d-sm-flex justify-content-sm-end"><a target="_blank" href="https://app.utrsports.net/clubs/'+''+id+'" class="btn-black-sm btn-outline-black text-uppercase font-sm-14">REGISTER NOW</a></div></div></div>';
            
            clubData.clubIds.push(id);
            eventLocations.push([llat,llng,clubName,cCount,id]);
            cCount+=1;
            
          }
          
        });
        
        var element_flex = document.getElementById("flex");

        if (element_flex) {
          element_flex.innerHTML=data;
          if (data) {
            fetchEventsData(); 
          }
        }

        reloadMarkers();
        
      }).catch(error => console.log('error', error));

  }
  
  //Fetch Events for Clubs
  function fetchEventsData(){
    console.log("fetchEventsData");
    const fetchURL = "https://api.utrsports.net/v1/events/latest";
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(clubData),
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.json())
      .then((result) => {
        
        result.hits.map((values)=>{
        
          var eventId = values.source.id;
          var eventName = values.source.name;  
          var clubId = values.source.club.id;
          var eventStartShort = values.source.eventSchedule.eventStartShort;

          var element_eventStartDate = document.getElementById('flexEventStartDate_'+clubId);
          var element_eventName = document.getElementById('flexEventName_'+clubId);
          if (element_eventStartDate) {
            element_eventStartDate.innerHTML='<p class="font-lg-14 font-sm-12 mb-0 mt-0 px-lg-2 d-sm-block">Register Now for '+eventStartShort+' Session</p>';
          }
          if (element_eventName) {
            element_eventName.innerHTML='<p class="font-lg-14 font-sm-12 mb-0 pb-sm-4"><span class="text-decoration-underline d-sm-block">'+eventName+'</span></p>';          
          }
        });
      }).catch(error => console.log('error', error));          
  }

  function fetchDataFromGoogleMapAPI(region){
    console.log("fetchDataFromGoogleMapAPI");

    if (!region) {
      fetchClubs("https://api.utrsports.net/v2/search/clubs/13");
    } else {
          const fetchURL = 'https://maps.googleapis.com/maps/api/geocode/json?address='+region+'&key=AIzaSyCapzh9VsfXAzC9fAaosZJulONx7H1BFaY&language=en';
    let latVal = "";
    let longVal = "";
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.text())
      .then((data) => {
        let result = JSON.parse(data);
        if (result.results.length > 0) {
          console.log(result.results);
          latVal = result.results[0].geometry.location.lat;
          longVal = result.results[0].geometry.location.lng;
          if (latVal && longVal) {
             fetchClubs('https://api.utrsports.net/v2/search/clubs/13?distance='+distanceText+'mi&pin='+latVal+','+longVal);
          }          
        }
      })
      .catch(error => console.log('error', error));      
    }    
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'; 
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  //Signup Newsletter
  let emailInputE = document.getElementById('ut-ns-emailInput');
  
  $("#ut-ns-submitBtn").click(function(e) {
    e.preventDefault();
    var nsform = document.forms['signup-ns-form']; //or this.parentNode

    if (nsform.subscribeEmail.value == "") {
      alert( "Please enter a valid email ID to subscribe!" );
      nsform.subscribeEmail.focus() ;
      return false;
    } else if (!validateEmail(nsform.subscribeEmail.value)) {
      alert( "Please enter a valid email ID to subscribe!" );
      nsform.subscribeEmail.focus() ;
      return false;            
    } else {
      submitSignupData(); 
    }
  });

  var nsData = {
  };
    
  //Submit Form Data
  function submitSignupData(){
    console.log("submitSignupData");

    nsData.email = emailInputE.value;

    const fetchURL = "https://api.universaltennis.com/v1/mailinglist/global";
    console.log('NS DATA = '+JSON.stringify(nsData));
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(nsData),
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.json(
        alert('Thanks you for subscribing!')
      ))
      .catch(error => console.log('error', error));          
  }

  function validateEmail(emailText) {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (emailText.match(validRegex)) {
      return true;
    } else { 
      return false;
    }
  }  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-in-touch"] && !Shopify.designMode) return;
  try {
    

  let typeInputE = document.getElementById('ut-git-typeSelect');
  let sportsTypeInputE = document.getElementById('ut-git-sportsTypeSelect');
  let firstNInputE = document.getElementById('ut-git-fnInput');
  let lastNInputE = document.getElementById('ut-git-lnInput');
  let emailInputE = document.getElementById('ut-git-emailInput');
  let phoneNInputE = document.getElementById('ut-git-phoneNumberInput');
  let descriptionSelectE = document.getElementById('ut-git-descriptionSelect');
  let titleInputE = document.getElementById('ut-git-titleInput');
  let countrySelectE = document.getElementById('ut-git-countrySelect');
  let stateSelectE = document.getElementById('ut-git-usStateSelect');
  let heardFromSelectE = document.getElementById('ut-git-heardFromSelect');
  let orgNInputE = document.getElementById('ut-git-orgInput');
  let submitButtonE = document.getElementById('ut-git-submitBtn');
  let countryDropDown = document.querySelectorAll('#country-select ul li a');
  var gitData = {
  };

  document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('ut-git-phoneNumberInput').value = '+1';
});


  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  //OnChange for What Describes you best? 
  $("#ut-git-typeSelect").change(function () {
    var selectedValue = $(this).val(); 
    if (selectedValue == 2){ 
      //Open in full size popup
      //window.open("https://support.universaltennis.com/support/home", "_blank","toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=4000,height=4000");
      //window.location.href = "/"; 

      //Open in same window
      window.location.href = "https://support.universaltennis.com/support/home"; 

          // Reset the dropdown value to 0
    $(this).val("0");

      
    } else if (selectedValue == 3) {
      // let emailTo = 'get-in-touch@universaltennis.com'; 
      // let emailCC = '';
      // let emailSub = 'Inquiry for Potential Partner | Universal Tennis Website';
      // let emailBody = '';
      // window.location.href = "mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+emailBody;
      // sleep(1000).then(() => { window.location.href = "/";  });
       // Display the overlay and popup using Magnific Popup
            $.magnificPopup.open({
                items: {
                    src: '#mailuspopup',
                    type: 'inline'
                },
                callbacks: {                    
                    close: function() {
                        // Reset the dropdown value when the popup is closed
                        $(this).val("0");
                    }
                }
                
            });
      $(this).val("0");
    } else {
          $.magnificPopup.close();
    }
  });

  function formatDate(date) {
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    return {
        day: day,
        month: month,
        year: year,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
};
  
  //Form Validation
  $("#ut-git-submitBtn").click(function(e) {
    e.preventDefault(); 
    var form = document.forms['get-in-touch-form']; //or this.parentNode
    console.log("FORM = "+form.fName);
    //describeTypeSelect fName lName Email mPhone dOrganization cCountry hearAboutFrom orgName
    if (form.describeTypeSelect.value == "" || form.describeTypeSelect.value == "0" ) {
      alert( "Please select what best describes you best!" );
      form.describeTypeSelect.focus() ;
      return false;
    } else if (form.describeTypeSelect.value == "3") {
      alert( "Please select different option for what best describes you best!" );
      form.describeTypeSelect.focus() ;
      return false;      
    } else if (form.sportsTypeSelect.value == "") {
      alert( "Please select the sports type!" );
      form.sportsTypeSelect.focus() ;
      return false;
    } else if (form.fName.value == "") {
      alert( "First name is required!" );
      form.fName.focus() ;
      return false;
    } else if (form.lName.value == "") {
      alert( "Last name is required!" );
      form.lName.focus() ;
      return false;      
    } else if (form.Email.value == "") {
      alert( "Email is required!" );
      form.Email.focus() ;
      return false;      
    } else if (form.mPhone.value == "" || form.mPhone.value.length < 12) {
      alert( "A valid phone number is required!" );
      form.mPhone.focus() ;
      return false;      
    } else if (form.dOrganization.value == "") {
      alert( "Please select what best describes your organization!" );
      form.dOrganization.focus() ;
      return false;      
    } else if (form.cCountry.value == "") {
      alert( "Country name is required!" );
      form.cCountry.focus() ;
      return false;      
    } else if (form.hearAboutFrom.value == "") {
      alert( "Please enter how did you hear about us!" );
      form.hearAboutFrom.focus() ;
      return false;      
    } else if (form.orgName.value == "") {
      alert( "Organization name is required!" );
      form.orgName.focus() ;
      return false;
    } else if (!validateEmail(form.Email.value)) {
      alert( "Please enter a valid email address!" );
      form.Email.focus() ;
      return false;            
    } else if (form.cCountry.value == "UnitedStates") {
       if (form.cState.value == "") {
         alert( "Please select a state!" );
         form.cState.focus() ;
         return false;
       } else {
         submitContactData();
       }       
    } else {
      submitContactData(); 
    }

  });

  function validateEmail(emailText) {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (emailText.match(validRegex)) {
      return true;
    } else {
      return false;
    }
  }

  //Submit Form Data
  function submitContactData(){
    console.log("submitContactData");
    gitData.type = typeInputE.value;
    gitData.sportsType = sportsTypeInputE.value;
    gitData.firstName = firstNInputE.value;
    gitData.lastName = lastNInputE.value;
    gitData.email = emailInputE.value;
    gitData.phone = phoneNInputE.value.replace(/\s/g, "");
    gitData.title = titleInputE.value;
    gitData.country = countrySelectE.value;
    gitData.state = stateSelectE.value;
    gitData.organization = orgNInputE.value;
    gitData.description = descriptionSelectE.value;
    gitData.heardFrom = heardFromSelectE.value;;
    gitData.headerFromOther = "";
    let currentDatetime = new Date();
    let datetimeString = formatDate(currentDatetime);
    console.log(datetimeString);
    gitData.date = datetimeString.day;
    gitData.month = datetimeString.month;
    gitData.year = datetimeString.year;
    // const checkbox = document.getElementById('showDivCheckbox');
    // let isChecked = checkbox.checked;
    // let valueCheckBox = isChecked ? 'Yes' : 'No';
    // gitData.subscriber = valueCheckBox;
    
    //const fetchURL = "https://api.universaltennis.com/v1/support/getintouch";
    const fetchURL = "https://hooks.zapier.com/hooks/catch/16287605/35roesg/"; 
    
    
    console.log('GIT DATA = '+JSON.stringify(gitData));
    //var myHeaders = new Headers();
    //myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'POST',
      body: JSON.stringify(gitData)
    };
    
    console.log(requestOptions);
    fetch(fetchURL, requestOptions)
      .then(function(){
        window.location.href = 'https://www.utrsports.net/pages/get-in-touch-thank-you';
        // alert('Thanks you for sharing details! We will get back to you shortly.');
      });
  }
  
  /*---------------Phone number formatter---------------*/
  const isNumericInput = (event) => {
  const key = event.keyCode;
  return (
    (key >= 48 && key <= 57) || // Allow number line
    (key >= 96 && key <= 105) // Allow number pad
  );
};

const isModifierKey = (event) => {
  const key = event.keyCode;
  return (
    (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
    (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
    (key > 36 && key < 41) || // Allow left, up, right, down
    (event.ctrlKey === true || event.metaKey === true) && // Allow Ctrl/Command + A,C,V,X,Z
    (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
  );
};
  
  const enforceFormat = (event) => {
      // Input must be of a valid number format or a modifier key, and not longer than ten digits
      if(!isNumericInput(event) && !isModifierKey(event)){
          event.preventDefault();
      }
  };

const formatToPhone = (event) => {
  const selectedCountryCode = event.target.value.replace(/\D/g, "").substring(0, 3);
  const countryList = document.querySelectorAll("#country-select ul li a");
  let phoneNumber = event.target.value;

  countryList.forEach((country) => {
    if (country.getAttribute("cunt_code") === `+${selectedCountryCode}`) {
      const countryName = country.querySelector("span:nth-child(2)").textContent;
      const countryFlag = country.querySelector("span:first-child").style.backgroundPosition;
      const countryDt = document.querySelector("#country-select dt a");
      countryDt.innerHTML = `<span><span style="background-position:${countryFlag}"></span><span>${countryName}</span><span>+${selectedCountryCode}</span></span>`;

      // Format the phone number
      phoneNumber = formatPhoneNumber(phoneNumber, selectedCountryCode);
      
    }
  });

  if (isModifierKey(event)) {
    return;
  }
  // Set the formatted phone number back to the input value
  event.target.value = phoneNumber;
  console.log("main", phoneNumber.replace(/\s/g, ""));
};

const formatPhoneNumber = (phoneNumber, countryCode) => {
  let formattedPhoneNumber = phoneNumber.replace(/\D/g, "");
  if (countryCode.length === 1) {
    formattedPhoneNumber = `+${countryCode.substr(0, 1)} ${formattedPhoneNumber.substr(1, 4)} ${formattedPhoneNumber.substr(4, 7)} ${formattedPhoneNumber.substr(10)}`;
  } else if (countryCode.length === 2) {
    formattedPhoneNumber = `+${countryCode.substr(0, 2)} ${formattedPhoneNumber.substr(3, 7)} ${formattedPhoneNumber.substr(8,10)}`;
    console.log(formattedPhoneNumber)
  } else if (countryCode.length >= 3 ) {
    formattedPhoneNumber = `+${countryCode.substr(0, 3)} ${formattedPhoneNumber.substr(3, 10)}`;
  }
  return formattedPhoneNumber;
};

const countryList = document.querySelectorAll("#country-select ul li a");
countryList.forEach(function (liElement) {
  liElement.addEventListener("click", function () {
    var selectedCode = this.getAttribute("cunt_code");
    phoneNInputE.value = selectedCode;
  });
});

phoneNInputE.addEventListener("keydown", enforceFormat);
phoneNInputE.addEventListener("keyup", formatToPhone); 
  
  /*---------------Phone number formatter---------------*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-features-text-button"] && !Shopify.designMode) return;
  try {
    
  /* (Optional) Add JS if needed for carousel initialization or custom behavior. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leaderboard-section"] && !Shopify.designMode) return;
  try {
    

   var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

    //2nd

    // fetch("https://api.universaltennis.com/v2/search?type=clubs&startDate=05/16/2021&utrFitPosition=6&utrMax=16&utrMin=1&utrTeamType=singles&utrType=verified", requestOptions)
    // .then(response => response.json())
    // .then((result) => {
    //   let data="";
    //   let i=1;

    //     result.players.hits.map((values)=>{
    //     if(values.source.clubMemberships[0].clubId == 750347 && values.source.thirdPartyRankings[0].rank == 2){
    //     if(i < 2){
    //     var score = values.score.toString().substr(0, 3);
    //     var rating = values.source.singlesUtrDisplay;
    //     var name = values.source.displayName;
    //     var location = values.source.location.display;

    //     data +='<div class="blue-teal-gradient-bg border-radius-lg-3 border-radius-sm-3 shadow-xl p-2 position-relative racepoint-top-sm"><div class="racepoint racepoint2 d-flex align-items-center justify-content-center"><div>2</div><div><span>nd</span></div></div><div class="d-flex justify-content-between align-items-center pb-lg-1 mb-sm-1"><div><p class="font-lg-14 font-sm-12 mb-0 mt-0 fw-bold text-black">Score</p><p class="font-lg-28 font-sm-28 mb-0 mt-0 text-black font-tungsten text-center">'+score+'</p></div><div><p class="font-lg-14 font-sm-12 mb-0 mt-0 fw-bold text-black">UTR Rating</p><p class="font-lg-28 font-sm-28 mb-0 mt-0 text-black font-tungsten text-center">'+rating+'</p></div></div><div class="text-center"><h3 class="mt-1 mb-0 font-lg-20 font-md-16 fw-bold">'+name+'</h3><p class="mt-0 mb-0 font-lg-14 font-sm-12 fw-bold">'+location+'</p></div>   </div>';
    //       }
    //     }
    //     });

    //   document.getElementById("2nd").innerHTML=data;

    // })
    // .catch(error => console.log('error', error));

    //1st

    // fetch("https://api.universaltennis.com/v2/search?type=clubs&startDate=05/16/2021&utrFitPosition=6&utrMax=16&utrMin=1&utrTeamType=singles&utrType=verified", requestOptions)
    // .then(response => response.json())
    // .then((result) => {
    //   let data="";
    //   let i=1;

    //     result.players.hits.map((values)=>{

    //     if(values.source.clubMemberships[0].clubId == 750347 && values.source.thirdPartyRankings[0].rank == 1){
    //     if(i < 2){
    //     var score = values.score.toString().substr(0, 3);
    //     var rating = values.source.singlesUtrDisplay;
    //     var name = values.source.displayName;
    //     var location = values.source.location.display;

    //     data +='<div class="blue-teal-gradient-bg border-radius-lg-3 border-radius-sm-3 shadow-xl p-2 position-relative racepoint-top-sm"><div class="racepoint racepoint2 d-flex align-items-center justify-content-center"><div>1</div><div><span>st</span></div></div><div class="d-flex justify-content-between align-items-center pb-lg-1 mb-sm-1"><div><p class="font-lg-14 font-sm-12 mb-0 mt-0 fw-bold text-black">Score</p><p class="font-lg-28 font-sm-28 mb-0 mt-0 text-black font-tungsten text-center">'+score+'</p></div><div><p class="font-lg-14 font-sm-12 mb-0 mt-0 fw-bold text-black">UTR Rating</p><p class="font-lg-28 font-sm-28 mb-0 mt-0 text-black font-tungsten text-center">'+rating+'</p></div></div><div class="text-center"><h3 class="mt-1 mb-0 font-lg-20 font-md-16 fw-bold">'+name+'</h3><p class="mt-0 mb-0 font-lg-14 font-sm-12 fw-bold">'+location+'</p></div>   </div>';
    //       }
    //     }
    //     });

    //   document.getElementById("1st").innerHTML=data;

    // })
    // .catch(error => console.log('error', error));

    // //3rd

    // fetch("https://api.universaltennis.com/v2/search?type=clubs&startDate=05/16/2021&utrFitPosition=6&utrMax=16&utrMin=1&utrTeamType=singles&utrType=verified", requestOptions)
    // .then(response => response.json())
    // .then((result) => {
    //   let data="";
    //   let i=1;

    //     result.players.hits.map((values)=>{
    //     if(values.source.clubMemberships[0].clubId == 750347 && values.source.thirdPartyRankings[0].rank == 3){
    //     if(i < 2){
    //     var score = values.score.toString().substr(0, 3);
    //     var rating = values.source.singlesUtrDisplay;
    //     var name = values.source.displayName;
    //     var location = values.source.location.display;

    //     data +='<div class="blue-teal-gradient-bg border-radius-lg-3 border-radius-sm-3 shadow-xl p-2 position-relative racepoint-top-sm"><div class="racepoint racepoint2 d-flex align-items-center justify-content-center"><div>3</div><div><span>rd</span></div></div><div class="d-flex justify-content-between align-items-center pb-lg-1 mb-sm-1"><div><p class="font-lg-14 font-sm-12 mb-0 mt-0 fw-bold text-black">Score</p><p class="font-lg-28 font-sm-28 mb-0 mt-0 text-black font-tungsten text-center">'+score+'</p></div><div><p class="font-lg-14 font-sm-12 mb-0 mt-0 fw-bold text-black">UTR Rating</p><p class="font-lg-28 font-sm-28 mb-0 mt-0 text-black font-tungsten text-center">'+rating+'</p></div></div><div class="text-center"><h3 class="mt-1 mb-0 font-lg-20 font-md-16 fw-bold">'+name+'</h3><p class="mt-0 mb-0 font-lg-14 font-sm-12 fw-bold">'+location+'</p></div>   </div>';
    //       }
    //     }
    //     });

    //   document.getElementById("3rd").innerHTML=data;

    // })
    // .catch(error => console.log('error', error));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
        var images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(function(img) {
            img.src = img.dataset.src;
          
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // document.addEventListener("DOMContentLoaded", function() {
  //       var images = document.querySelectorAll('img[loading="lazy"]');
  //       images.forEach(function(img) {
  //           img.src = img.dataset.src;
          
  //       });
  //   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-gradient-text-header"] && !Shopify.designMode) return;
  try {
    

  let tour = 'UTR Pro Tennis Tour';
  let eventState = 'open_registration';
  let teamType = '';
  let gender = '';
  let region = '';

  const date = new Date();
  let dayToday = date.getDate();
  let monthToday = date.getMonth() + 1;
  let currentYear = date.getFullYear(); 

  let range = '';
  let range1 = 'eventSchedule.eventStartUtc<='+dayToday+'/'+monthToday+'/'+currentYear;
  let range2 = 'eventSchedule.eventStartUtc>='+dayToday+'/'+monthToday+'/'+currentYear; 

  let upcomingDateRange = [];
  let searchQuery = '';
  // let currentItem = 6;
  let pttLoadMoreBtn = document.querySelector('.ut-ptt-load-more-btn');
  let shareLink = document.querySelector('.share-link');  
  let searchBtn = document.querySelector('.search-button-ptt-tour');  
  let searchInputElement = document.querySelector('.search_input-ptt-tour');

  //Set Drop Down for Upcoming Range
  setUpcomingRangeOptions();
  
  //Fetch all events 
  fetchEvents();

  //Search Functionality
  $('#search_input-ptt-tour').keypress(function (e) {                                       
       if (e.which == 13) {
         e.preventDefault();
         
         //do something    
         searchQuery = document.getElementById('search_input-ptt-tour').value;
         fetchEvents();

       }
  });  
  
  const inputHandler = function(e) {
    searchQuery = e.target.value;
    console.log(searchQuery);
  }
  searchInputElement.addEventListener('input', inputHandler);
  
  //Search Functionality
  searchBtn.onclick = () => {
    searchQuery = document.getElementById('search_input-ptt-tour').value;
    fetchEvents();
  }


  //Share Functionality
  function shareClicked() {
  
    console.log('shareClicked');
    if (navigator.share) {
      navigator.share({
        title: 'WebShare API Demo',
        url: 'https://codepen.io/ayoisaiah/pen/YbNazJ'
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(console.error);    
    } else {
      console.log('Browser not supporting Web Share!');
    }

  }
  
  // //Load More Functionality
  // pttLoadMoreBtn.onclick = () => {
  //   console.log("loadmore clicked");
    
  //   let boxes = [...document.querySelectorAll('.container-wrap .box-container')];
            
  //   for (var i = 0; i < boxes.length; i++) {
  //     boxes[i].style.display = "inline-block";
  //   }
  
  // }

  // function displayLoadMore(isDisplay) {
  //   if(isDisplay) {
  //     pttLoadMoreBtn.style.display = "inline-block";
  //   } else {
  //     pttLoadMoreBtn.style.display = "none";
  //   }
  // }

  //Filter by gender
  document.getElementById("genderSelect").onchange = function() {selectGender()};

  function selectGender() {
    gender = document.getElementById("genderSelect").value;
    fetchEvents();
  }
 
  //Filter by event state
  document.getElementById("eventStateSelect").onchange = function() {selectEventState()};

  function selectEventState() {
    eventState = document.getElementById("eventStateSelect").value;
    fetchEvents();
  }

  /* Comment | No Api available for team type select singles & doubles
  //Filter by team type
  document.getElementById("teamTypeSelect").onchange = function() {selectTeamType()};
  function selectTeamType() {
    teamType = document.getElementById("teamTypeSelect").value;
    fetchEvents();
  }
  */
  
  //Filter by team type
  document.getElementById("regionSelect").onchange = function() {selectRegion()};

  function selectRegion() {
    region = document.getElementById("regionSelect").value;
    fetchEvents();
  }

  function selectRange() {
    range = document.getElementById("rangeSelect").value;
    const dateRange = range.split(' - ');
const startDate = dateRange[0];
const endDate = dateRange[1];
    if (range) {
      range1 = 'eventSchedule.eventStartUtc>='+ startDate;
      range2 = 'eventSchedule.eventStartUtc<='+ endDate; 
    }    

    fetchEvents(); 
  }

  //Fetch Events 
 function fetchEvents() {
  document.getElementById("not_login_user").innerHTML = "Fetching....";

   range = document.getElementById("rangeSelect").value;
    const dateRange = range.split(' - ');
const startDate = dateRange[0];
const endDate = dateRange[1];
      
  let i = 0;
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  const maleApiUrl = 'https://api.utrsports.net/v2/search/events?tours=' + tour + '&eventState=' + eventState + '&top=250&skip=0' + (searchQuery != "" ? '&query=' + searchQuery : "") + '&gender=M' + (teamType != "" ? '&teamType=' + teamType : "") + (range != "" ? '&range=' + 'eventSchedule.eventStartUtc>='+ startDate + '&range=' + 'eventSchedule.eventStartUtc<='+ endDate : "");
  const femaleApiUrl = 'https://api.utrsports.net/v2/search/events?tours=' + tour + '&eventState=' + eventState + '&top=250&skip=0' + (searchQuery != "" ? '&query=' + searchQuery : "") + '&gender=F' + (teamType != "" ? '&teamType=' + teamType : "") + (range != "" ? '&range=' + 'eventSchedule.eventStartUtc>='+ startDate + '&range=' + 'eventSchedule.eventStartUtc<='+ endDate : ""); 

  // Function to fetch data from an API
  const fetchData = (url, params) => {
    return fetch(url, { method: "GET", body: JSON.stringify(params), redirect: "follow" })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => data.hits)
      .catch((error) => {
        console.error("Error:", error);
        return null;
      });
  };
  // Fetch data from the male and female APIs
  const malePromise = fetchData(maleApiUrl);
  const femalePromise = fetchData(femaleApiUrl);

  // Use Promise.all to combine responses when both are available
  Promise.all([malePromise, femalePromise])
    .then(([maleData, femaleData]) => {
      if (maleData && femaleData) {
        // Merge the data arrays into a single array
        let combinedData = []
        if(gender === 'm') {
           combinedData = [...maleData];
        } else if (gender === "f"){
           combinedData = [ ...femaleData];
        } else {
         
         combinedData = [...maleData, ...femaleData];
        }
                const sortedData = combinedData.sort((maleData, femaleData) => {
  const dateA = new Date(maleData.source.eventSchedule.eventStartUtc);
  const dateB = new Date(femaleData.source.eventSchedule.eventStartUtc);                  
 
  return dateA - dateB;
});

        let data = "";
        const eventsByMonth = {};
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        

        console.log("the sortedData", sortedData)

sortedData.forEach((values) => {
  const eventStartDate = new Date(values.source.eventSchedule.eventStartUtc);
  const eventStartMonth = monthNames[eventStartDate.getMonth()]; 
  const eventStartYear = values.source.eventSchedule.eventStartYear;
  const eventmonthandyear = `${eventStartMonth}  ${eventStartYear}`; // Use backticks here

  if (!eventsByMonth[eventmonthandyear]) {
    eventsByMonth[eventmonthandyear] = [];
  }

    eventsByMonth[eventmonthandyear].push(values);

});

  for (const month in eventsByMonth) {
  // Create an HTML element to represent the month
  data += `<h3 class="month-title text-uppercase gotham-medium fst-italic font-sm-12 min-w-lg-180 min-w-sm-160 mb-0 custom-margin-bottom" style="color: #fff;">${month}</h3>`;

  data += '<div class="grid container-wrap grid--1-col grid--1-col-tablet grid--3-col-desktop d-flex align-items-center pt-lg-2 pb-lg-2 clear-both">';

       
  // Iterate over the events in this month
  eventsByMonth[month].forEach((values) => {
      
  var id = values.source.id;
  var name = values.source.name;
  var club = values.source.club.name;
    // Kiểm tra xem eventLocations có phần tử hay không
  var location = (values.source.eventLocations && values.source.eventLocations.length > 0)
    ? values.source.eventLocations[0].display
    : 'undefined';  // Gán 'undefined' nếu eventLocations rỗng

  var eventStartDate = values.source.eventSchedule.eventStartDate;
  var eventEndDate = values.source.eventSchedule.eventEndDate;
  var eventStartMonth = values.source.eventSchedule.eventStartMonth;
  var eventEndMonth = values.source.eventSchedule.eventEndMonth;
  var eventRegStateValue = values.source.eventState.value;
  var eventIsInProgress = false;
  var eventRegButtonTitle = 'View';
  var gender = values.source.gender;
  var outdoor = values.source.eventDivisions && values.source.eventDivisions[0].environments.length > 0 ? values.source.eventDivisions[0].environments[0].label : '';
  var hard = values.source.eventDivisions && values.source.eventDivisions[0].surfaces.length > 0 ? values.source.eventDivisions[0].surfaces[0].label : '';

  if (eventRegStateValue == 'open_registration') {
    eventRegButtonTitle = 'Register';
  }

  if (eventRegStateValue == 'in_progress') {
    eventIsInProgress = true;
  }
  if (region) {
    if (club.includes(region)) {
      data += '<div class="grid__item box-container"><div class="blue-teal-gradient-bg min-h-260 border-radius-lg-3 border-radius-sm-3 custom-m-height-mobile"><div class="custom-position feature-card-box fs-p-2"><div class="d-flex justify-content-between mb-1"><div><h4 class="fs-sm-14">' + name + '</h4><p class="gotham-medium font-lg-14 font-sm-13 lh-sm-normal fs-mt-0">' + club + '</p></div>';
      if (eventIsInProgress) {
        data += '<a href="https://www.amazon.com/gp/video/storefront/ref=atv_me_pvs_c_hvqwaq_11_smr?contentType=tournament&contentId=amzn1.dv.icid.a7897353-fd02-4669-b996-4866f0c19710" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0690/8071/1488/files/prime-video.png?v=1673424280" width="36" height="36"></a>';
      }
      data += '</div> <div class="d-flex align-items-center contact-icon"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00039 13.5812C6.37907 13.5812 7.85934 12.4999 9.0389 11.1583C10.6113 9.37123 11.5691 7.3766 11.5691 5.4812C11.5691 2.48116 9.1037 0.418701 6.00039 0.418701C2.89708 0.418701 0.431641 2.48116 0.431641 5.4812C0.431641 7.3847 1.38947 9.37933 2.96188 11.1644C4.14043 12.5029 5.6207 13.5812 6.00039 13.5812ZM6.00039 8.9237C5.14109 8.9237 4.31698 8.58235 3.70936 7.97473C3.10175 7.36711 2.76039 6.543 2.76039 5.6837C2.76039 4.8244 3.10175 4.00029 3.70936 3.39268C4.31698 2.78506 5.14109 2.4437 6.00039 2.4437C6.85969 2.4437 7.6838 2.78506 8.29142 3.39268C8.89903 4.00029 9.24039 4.8244 9.24039 5.6837C9.24039 6.543 8.89903 7.36711 8.29142 7.97473C7.6838 8.58235 6.85969 8.9237 6.00039 8.9237Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + location + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.35007 15.6425C3.98471 15.6425 3.67183 15.5125 3.41142 15.2526C3.15146 14.9922 3.02148 14.6793 3.02148 14.3139V5.01385C3.02148 4.64849 3.15146 4.33583 3.41142 4.07587C3.67183 3.81547 3.98471 3.68527 4.35007 3.68527H5.01436V2.35669H6.34294V3.68527H11.6573V2.35669H12.9859V3.68527H13.6501C14.0155 3.68527 14.3284 3.81547 14.5888 4.07587C14.8487 4.33583 14.9787 4.64849 14.9787 5.01385V14.3139C14.9787 14.6793 14.8487 14.9922 14.5888 15.2526C14.3284 15.5125 14.0155 15.6425 13.6501 15.6425H4.35007ZM4.35007 14.3139H13.6501V7.67102H4.35007V14.3139ZM6.34203 13.0078C6.15381 13.0078 5.99593 12.944 5.86839 12.8165C5.74129 12.6894 5.67773 12.5317 5.67773 12.3435C5.67773 12.1553 5.74129 11.9974 5.86839 11.8699C5.99593 11.7427 6.15381 11.6792 6.34203 11.6792C6.53024 11.6792 6.68812 11.7427 6.81567 11.8699C6.94277 11.9974 7.00632 12.1553 7.00632 12.3435C7.00632 12.5317 6.94277 12.6894 6.81567 12.8165C6.68812 12.944 6.53024 13.0078 6.34203 13.0078ZM8.99919 13.0078C8.81097 13.0078 8.65332 12.944 8.52621 12.8165C8.39867 12.6894 8.3349 12.5317 8.3349 12.3435C8.3349 12.1553 8.39867 11.9974 8.52621 11.8699C8.65332 11.7427 8.81097 11.6792 8.99919 11.6792C9.18741 11.6792 9.34529 11.7427 9.47283 11.8699C9.59993 11.9974 9.66348 12.1553 9.66348 12.3435C9.66348 12.5317 9.59993 12.6894 9.47283 12.8165C9.34529 12.944 9.18741 13.0078 8.99919 13.0078ZM11.6564 13.0078C11.4681 13.0078 11.3105 12.944 11.1834 12.8165C11.0558 12.6894 10.9921 12.5317 10.9921 12.3435C10.9921 12.1553 11.0558 11.9974 11.1834 11.8699C11.3105 11.7427 11.4681 11.6792 11.6564 11.6792C11.8446 11.6792 12.0022 11.7427 12.1293 11.8699C12.2569 11.9974 12.3206 12.1553 12.3206 12.3435C12.3206 12.5317 12.2569 12.6894 12.1293 12.8165C12.0022 12.944 11.8446 13.0078 11.6564 13.0078ZM5.86839 10.137C5.99593 10.2646 6.15381 10.3283 6.34203 10.3283C6.53024 10.3283 6.68812 10.2646 6.81567 10.137C6.94277 10.0099 7.00632 9.85226 7.00632 9.66405C7.00632 9.47583 6.94277 9.31795 6.81567 9.19041C6.68812 9.06331 6.53024 8.99976 6.34203 8.99976C6.15381 8.99976 5.99593 9.06331 5.86839 9.19041C5.74129 9.31795 5.67773 9.47583 5.67773 9.66405C5.67773 9.85226 5.74129 10.0099 5.86839 10.137ZM8.52621 10.137C8.65332 10.2646 8.81097 10.3283 8.99919 10.3283C9.18741 10.3283 9.34529 10.2646 9.47283 10.137C9.59993 10.0099 9.66348 9.85226 9.66348 9.66405C9.66348 9.47583 9.59993 9.31795 9.47283 9.19041C9.34529 9.06331 9.18741 8.99976 8.99919 8.99976C8.81097 8.99976 8.65332 9.06331 8.52621 9.19041C8.39867 9.31795 8.3349 9.47583 8.3349 9.66405C8.3349 9.85226 8.39867 10.0099 8.52621 10.137ZM11.1834 10.137C11.3105 10.2646 11.4681 10.3283 11.6564 10.3283C11.8446 10.3283 12.0022 10.2646 12.1293 10.137C12.2569 10.0099 12.3206 9.85226 12.3206 9.66405C12.3206 9.47583 12.2569 9.31795 12.1293 9.19041C12.0022 9.06331 11.8446 8.99976 11.6564 8.99976C11.4681 8.99976 11.3105 9.06331 11.1834 9.19041C11.0558 9.31795 10.9921 9.47583 10.9921 9.66405C10.9921 9.85226 11.0558 10.0099 11.1834 10.137Z" fill="black"></path></svg><span class=" font-lg-13 font-sm-13 gotham-medium">' + eventStartMonth + ' ' + eventStartDate + ' - ' + eventEndMonth + ' ' + eventEndDate + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68068 10.0835C7.26379 10.8023 7.80656 11.4698 8.364 12.1519C8.64272 11.6825 8.64638 11.6128 8.47768 10.5309H9.42386V12.0895C9.48988 12.1152 9.55589 12.1372 9.6219 12.1629C10.1097 11.5578 10.6194 10.9673 11.0705 10.3365C11.2282 10.1202 11.3492 10.0505 11.5949 10.1055C11.7783 10.1458 11.9727 10.1422 12.1634 10.1458C13.3039 10.1788 14.0924 10.729 14.5912 11.7448C15.376 13.3474 15.0679 14.0809 13.3443 14.5687C11.7453 15.0198 10.0987 15.1078 8.45935 15.0234C7.1611 14.9537 5.85186 14.8181 4.59029 14.532C2.95464 14.1616 2.65392 13.3731 3.35439 11.8475C3.85681 10.7546 4.6783 10.1642 5.89587 10.1385C6.17458 10.1312 6.44964 10.0982 6.68435 10.0835H6.68068Z" fill="black"></path><path d="M8.99523 2.25C10.8802 2.25 12.0318 3.39055 12.0685 5.27924C12.0721 5.47361 12.1418 5.66798 12.1932 5.85868C12.3399 6.37944 12.2628 6.87454 11.9951 7.33662C11.8448 7.60067 11.6981 7.86839 11.5184 8.11044C11.1663 8.59086 10.8546 9.12263 10.4218 9.5187C9.53433 10.3402 8.4928 10.3219 7.56862 9.53337C7.31558 9.317 7.0772 9.06395 6.89383 8.7889C6.54543 8.2718 6.20437 7.7437 5.92565 7.18626C5.69827 6.72418 5.60292 6.22908 5.8743 5.71199C5.97332 5.52128 5.92565 5.25723 5.94398 5.02619C6.11268 3.24385 7.20556 2.25 8.99523 2.25ZM8.99523 9.65439C9.36196 9.49303 9.76537 9.42335 9.99641 9.18864C10.4365 8.73756 10.7776 8.18745 11.159 7.67769C11.2433 7.56767 11.2947 7.42464 11.401 7.34029C11.8154 6.99923 11.8521 6.46379 11.4744 6.05672C11.4267 6.00537 11.412 5.92836 11.3863 5.86235C11.137 5.23156 10.4622 4.91984 9.76537 4.99685C9.20793 5.05553 8.62482 5.04453 8.07105 4.95284C7.34125 4.83182 6.97818 4.96384 6.68112 5.64964C6.62245 5.78167 6.59677 5.94303 6.50876 6.04571C6.20437 6.39778 6.17869 6.90754 6.45008 7.23761C6.63711 7.46498 6.78381 7.7217 6.96351 7.95641C7.28257 8.37082 7.57229 8.81824 7.95736 9.16297C8.22141 9.40135 8.62116 9.4857 8.99523 9.65439Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + outdoor + ' | ' + hard + '</span></div><div class="custom-d-flex d-flex justify-content-center align-items-center mt-4"><a href="https://app.utrsports.net/events/' + '' + id + '" target="_blank" class="custom-min-w-sm-145 btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">' + eventRegButtonTitle + '</a> </div></div></div></div>';
      
      
    }
  } else {
    data += '<div class="grid__item box-container"><div class="blue-teal-gradient-bg min-h-260 border-radius-lg-3 border-radius-sm-3 custom-m-height-mobile"><div class="custom-position feature-card-box fs-p-2"><div class="d-flex justify-content-between mb-1"><div><h4 class="fs-sm-14">' + name + '</h4><p class="gotham-medium font-lg-14 font-sm-13 lh-sm-normal fs-mt-0">' + club + '</p></div>';
    if (eventIsInProgress) {
      data += '<a href="https://www.amazon.com/gp/video/storefront/ref=atv_me_pvs_c_hvqwaq_11_smr?contentType=tournament&contentId=amzn1.dv.icid.a7897353-fd02-4669-b996-4866f0c19710" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0690/8071/1488/files/prime-video.png?v=1673424280" width="36" height="36"></a>';
    }
    data += '</div> <div class="d-flex align-items-center contact-icon"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00039 13.5812C6.37907 13.5812 7.85934 12.4999 9.0389 11.1583C10.6113 9.37123 11.5691 7.3766 11.5691 5.4812C11.5691 2.48116 9.1037 0.418701 6.00039 0.418701C2.89708 0.418701 0.431641 2.48116 0.431641 5.4812C0.431641 7.3847 1.38947 9.37933 2.96188 11.1644C4.14043 12.5029 5.6207 13.5812 6.00039 13.5812ZM6.00039 8.9237C5.14109 8.9237 4.31698 8.58235 3.70936 7.97473C3.10175 7.36711 2.76039 6.543 2.76039 5.6837C2.76039 4.8244 3.10175 4.00029 3.70936 3.39268C4.31698 2.78506 5.14109 2.4437 6.00039 2.4437C6.85969 2.4437 7.6838 2.78506 8.29142 3.39268C8.89903 4.00029 9.24039 4.8244 9.24039 5.6837C9.24039 6.543 8.89903 7.36711 8.29142 7.97473C7.6838 8.58235 6.85969 8.9237 6.00039 8.9237Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + location + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.35007 15.6425C3.98471 15.6425 3.67183 15.5125 3.41142 15.2526C3.15146 14.9922 3.02148 14.6793 3.02148 14.3139V5.01385C3.02148 4.64849 3.15146 4.33583 3.41142 4.07587C3.67183 3.81547 3.98471 3.68527 4.35007 3.68527H5.01436V2.35669H6.34294V3.68527H11.6573V2.35669H12.9859V3.68527H13.6501C14.0155 3.68527 14.3284 3.81547 14.5888 4.07587C14.8487 4.33583 14.9787 4.64849 14.9787 5.01385V14.3139C14.9787 14.6793 14.8487 14.9922 14.5888 15.2526C14.3284 15.5125 14.0155 15.6425 13.6501 15.6425H4.35007ZM4.35007 14.3139H13.6501V7.67102H4.35007V14.3139ZM6.34203 13.0078C6.15381 13.0078 5.99593 12.944 5.86839 12.8165C5.74129 12.6894 5.67773 12.5317 5.67773 12.3435C5.67773 12.1553 5.74129 11.9974 5.86839 11.8699C5.99593 11.7427 6.15381 11.6792 6.34203 11.6792C6.53024 11.6792 6.68812 11.7427 6.81567 11.8699C6.94277 11.9974 7.00632 12.1553 7.00632 12.3435C7.00632 12.5317 6.94277 12.6894 6.81567 12.8165C6.68812 12.944 6.53024 13.0078 6.34203 13.0078ZM8.99919 13.0078C8.81097 13.0078 8.65332 12.944 8.52621 12.8165C8.39867 12.6894 8.3349 12.5317 8.3349 12.3435C8.3349 12.1553 8.39867 11.9974 8.52621 11.8699C8.65332 11.7427 8.81097 11.6792 8.99919 11.6792C9.18741 11.6792 9.34529 11.7427 9.47283 11.8699C9.59993 11.9974 9.66348 12.1553 9.66348 12.3435C9.66348 12.5317 9.59993 12.6894 9.47283 12.8165C9.34529 12.944 9.18741 13.0078 8.99919 13.0078ZM11.6564 13.0078C11.4681 13.0078 11.3105 12.944 11.1834 12.8165C11.0558 12.6894 10.9921 12.5317 10.9921 12.3435C10.9921 12.1553 11.0558 11.9974 11.1834 11.8699C11.3105 11.7427 11.4681 11.6792 11.6564 11.6792C11.8446 11.6792 12.0022 11.7427 12.1293 11.8699C12.2569 11.9974 12.3206 12.1553 12.3206 12.3435C12.3206 12.5317 12.2569 12.6894 12.1293 12.8165C12.0022 12.944 11.8446 13.0078 11.6564 13.0078ZM5.86839 10.137C5.99593 10.2646 6.15381 10.3283 6.34203 10.3283C6.53024 10.3283 6.68812 10.2646 6.81567 10.137C6.94277 10.0099 7.00632 9.85226 7.00632 9.66405C7.00632 9.47583 6.94277 9.31795 6.81567 9.19041C6.68812 9.06331 6.53024 8.99976 6.34203 8.99976C6.15381 8.99976 5.99593 9.06331 5.86839 9.19041C5.74129 9.31795 5.67773 9.47583 5.67773 9.66405C5.67773 9.85226 5.74129 10.0099 5.86839 10.137ZM8.52621 10.137C8.65332 10.2646 8.81097 10.3283 8.99919 10.3283C9.18741 10.3283 9.34529 10.2646 9.47283 10.137C9.59993 10.0099 9.66348 9.85226 9.66348 9.66405C9.66348 9.47583 9.59993 9.31795 9.47283 9.19041C9.34529 9.06331 9.18741 8.99976 8.99919 8.99976C8.81097 8.99976 8.65332 9.06331 8.52621 9.19041C8.39867 9.31795 8.3349 9.47583 8.3349 9.66405C8.3349 9.85226 8.39867 10.0099 8.52621 10.137ZM11.1834 10.137C11.3105 10.2646 11.4681 10.3283 11.6564 10.3283C11.8446 10.3283 12.0022 10.2646 12.1293 10.137C12.2569 10.0099 12.3206 9.85226 12.3206 9.66405C12.3206 9.47583 12.2569 9.31795 12.1293 9.19041C12.0022 9.06331 11.8446 8.99976 11.6564 8.99976C11.4681 8.99976 11.3105 9.06331 11.1834 9.19041C11.0558 9.31795 10.9921 9.47583 10.9921 9.66405C10.9921 9.85226 11.0558 10.0099 11.1834 10.137Z" fill="black"></path></svg><span class=" font-lg-13 font-sm-13 gotham-medium">' + eventStartMonth + ' ' + eventStartDate + ' - ' + eventEndMonth + ' ' + eventEndDate + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68068 10.0835C7.26379 10.8023 7.80656 11.4698 8.364 12.1519C8.64272 11.6825 8.64638 11.6128 8.47768 10.5309H9.42386V12.0895C9.48988 12.1152 9.55589 12.1372 9.6219 12.1629C10.1097 11.5578 10.6194 10.9673 11.0705 10.3365C11.2282 10.1202 11.3492 10.0505 11.5949 10.1055C11.7783 10.1458 11.9727 10.1422 12.1634 10.1458C13.3039 10.1788 14.0924 10.729 14.5912 11.7448C15.376 13.3474 15.0679 14.0809 13.3443 14.5687C11.7453 15.0198 10.0987 15.1078 8.45935 15.0234C7.1611 14.9537 5.85186 14.8181 4.59029 14.532C2.95464 14.1616 2.65392 13.3731 3.35439 11.8475C3.85681 10.7546 4.6783 10.1642 5.89587 10.1385C6.17458 10.1312 6.44964 10.0982 6.68435 10.0835H6.68068Z" fill="black"></path><path d="M8.99523 2.25C10.8802 2.25 12.0318 3.39055 12.0685 5.27924C12.0721 5.47361 12.1418 5.66798 12.1932 5.85868C12.3399 6.37944 12.2628 6.87454 11.9951 7.33662C11.8448 7.60067 11.6981 7.86839 11.5184 8.11044C11.1663 8.59086 10.8546 9.12263 10.4218 9.5187C9.53433 10.3402 8.4928 10.3219 7.56862 9.53337C7.31558 9.317 7.0772 9.06395 6.89383 8.7889C6.54543 8.2718 6.20437 7.7437 5.92565 7.18626C5.69827 6.72418 5.60292 6.22908 5.8743 5.71199C5.97332 5.52128 5.92565 5.25723 5.94398 5.02619C6.11268 3.24385 7.20556 2.25 8.99523 2.25ZM8.99523 9.65439C9.36196 9.49303 9.76537 9.42335 9.99641 9.18864C10.4365 8.73756 10.7776 8.18745 11.159 7.67769C11.2433 7.56767 11.2947 7.42464 11.401 7.34029C11.8154 6.99923 11.8521 6.46379 11.4744 6.05672C11.4267 6.00537 11.412 5.92836 11.3863 5.86235C11.137 5.23156 10.4622 4.91984 9.76537 4.99685C9.20793 5.05553 8.62482 5.04453 8.07105 4.95284C7.34125 4.83182 6.97818 4.96384 6.68112 5.64964C6.62245 5.78167 6.59677 5.94303 6.50876 6.04571C6.20437 6.39778 6.17869 6.90754 6.45008 7.23761C6.63711 7.46498 6.78381 7.7217 6.96351 7.95641C7.28257 8.37082 7.57229 8.81824 7.95736 9.16297C8.22141 9.40135 8.62116 9.4857 8.99523 9.65439Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + outdoor + ' | ' + hard + '</span></div><div class="custom-d-flex d-flex justify-content-center align-items-center mt-4"><a href="https://app.utrsports.net/events/' + '' + id + '" target="_blank" class="custom-min-w-sm-145 btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">' + eventRegButtonTitle + '</a> </div></div></div></div>';
    
  }
        });
  data += '</div>';
    
}
          document.getElementById("not_login_user").innerHTML = data;
 
      } else {
        console.log("One of the API requests failed.");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
  
  //Helper functions
 
  function getMonthNumberFromName(monthName) {
    var currentYear = new Date().getFullYear();
    return new Date(`${monthName} 1, ${currentYear}`).getMonth() + 1;
  }


  document.getElementById("rangeDateTypeSelect").onchange = function() { 
  let theDateType = document.getElementById("rangeDateTypeSelect");
  let rangeSelectDiv = document.getElementById("rangeDateMonthYearSelect");
   let theInput = document.getElementById("rangeSelect");

    let selectedMonthValue = {
  start: null,
  end: null,
};
    
    let selectedYearValue = ''

  if (theDateType.value === "1") {
    
    // Clear the existing content in the #rangeSelectDiv
    rangeSelectDiv.innerHTML = "";
    
// Create a dropdown for months with current month selected
let currentMonth = new Date().getMonth();
let monthDropdown = document.createElement("select");
monthDropdown.classList.add("text-uppercase", "gotham-medium", "fst-italic", "font-sm-12", "min-w-lg-180", "min-w-sm-160");
for (let i = 1; i <= 12; i++) { // Start from 1 for month
  let option = document.createElement("option");
  option.value = i;
  option.text = new Date(0, i - 1).toLocaleString('default', { month: 'long' });
  if (i === currentMonth + 1) {
    option.selected = true;
    selectedMonthValue = i;
  }
  monthDropdown.appendChild(option);
}

// Add an onchange event to the month dropdown
monthDropdown.addEventListener("change", function () {
  selectedMonthValue = parseInt(monthDropdown.value);
  updateTheInputValue();
});
    

// Create a dropdown for years with current year and the next 2 years
let currentYear = new Date().getFullYear();
let yearDropdown = document.createElement("select");
yearDropdown.classList.add("text-uppercase", "gotham-medium", "fst-italic", "font-sm-12", "min-w-lg-180", "min-w-sm-160");
yearDropdown.id = "yearSelect";
for (let i = currentYear - 2; i <= currentYear + 1; i++) {
  let option = document.createElement("option");
  option.value = i;
  option.text = i;
  if (i === currentYear) {
    option.selected = true;
    selectedYearValue = i;
  }
  yearDropdown.appendChild(option);
}

// Add an onchange event to the year dropdown
yearDropdown.addEventListener("change", function () {
  selectedYearValue = parseInt(yearDropdown.value);
  updateTheInputValue();
});

// Append the month and year dropdowns to #rangeSelectDiv
rangeSelectDiv.appendChild(monthDropdown);
rangeSelectDiv.appendChild(yearDropdown);

// Call a function to update the input value initially
updateTheInputValue();
    

  function updateTheInputValue() {
  const firstDate = new Date(selectedYearValue, selectedMonthValue - 1, 1);
  const lastDate = new Date(selectedYearValue, selectedMonthValue, 0);

  const formattedFirstDate = `${(firstDate.getMonth() + 1).toString().padStart(2, '0')}/${firstDate.getDate().toString().padStart(2, '0')}/${firstDate.getFullYear()}`;
  const formattedLastDate = `${(lastDate.getMonth() + 1).toString().padStart(2, '0')}/${lastDate.getDate().toString().padStart(2, '0')}/${lastDate.getFullYear()}`;

  theInput.value = `${formattedFirstDate} - ${formattedLastDate}`;
  selectRange();
}
  
  } else {
    // Clear the content if "theDateType" is not 1
    document.getElementById("rangeSelect").value = ""
    rangeSelectDiv.innerHTML = "";
    fetchEvents();
  }
};
  

  function setUpcomingRangeOptions(){
    
    let no_of_months = 12;
    let rangeElementHTML = '<input type="hidden" class="text-uppercase gotham-medium fst-italic font-sm-12 min-w-lg-180 min-w-sm-160" value="" id="rangeSelect" />';
    
    document.getElementById("rangeSelectDiv").innerHTML = rangeElementHTML;

    //Filter by team type
    document.getElementById("rangeSelect").onchange = function() {selectRange()};

  }
   
  // var getDaysInMonth = function(month,year) {
  //   // Here January is 1 based
  //   //Day 0 is the last day in the previous month
  //  return new Date(year, month, 0).getDate();
  // // Here January is 0 based
  // // return new Date(year, month+1, 0).getDate();
  // };

   // Custom button Event in progress 
  
  const eventStateSelect = document.getElementById('eventStateSelect');
const buttonGender = document.getElementById("genderSelect");
const buttonRegion = document.getElementById("regionSelect");

function getQueryParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        tab: params.get('tab') || '',
        region: params.get('region') || ''
    };
}

function updateUrl(tab, region) {
    const params = new URLSearchParams(window.location.search);

    if (tab) {
        params.set('tab', tab);
    } else {
        params.delete('tab');
    }

    if (region) {
        params.set('region', region.toLowerCase());
    } else {
        params.delete('region');
    }

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
}


function checkInProgress() {
    const eventStateValue = eventStateSelect.value;
    const selectedGender = buttonGender.value;
    const selectedRegion = buttonRegion.value;

    let genderFilter = '';
    if (selectedGender === 'm') genderFilter = 'Men';
    if (selectedGender === 'f') genderFilter = 'Women';

    let tabParam = '';
    if (eventStateValue === 'open_registration') tabParam = 'openregistration';
    if (eventStateValue === 'registration_closed') tabParam = 'registrationclosed';
    if (eventStateValue === 'in_progress') tabParam = 'inprogress';
    if (eventStateValue === 'completed') tabParam = 'completed';

    updateUrl(tabParam, selectedRegion);

    // ================= IN PROGRESS =================
    if (eventStateValue === 'in_progress') {
        const urlUpComing = 'https://api.utrsports.net/v2/search/proTennisTour?top=40&skip=0&utrType=verified&utrTeamType=doubles&searchOrigin=searchPage';
        const urlInProgress = 'https://api.utrsports.net/v2/search/proTennisTour?top=40&skip=0&utrType=verified&utrTeamType=doubles&sort=eventSchedule.eventStartUtc%3Adesc&showInProgressEvents=true&searchOrigin=searchPage';

        Promise.all([
            fetch(urlUpComing).then(r => r.json()),
            fetch(urlInProgress).then(r => r.json())
        ])
        .then(([dataUpComing, dataInProgress]) => {

            const filterFn = hit => {
                const clubRegion = hit.source.club.name.split(' - ')[1];
                return (!genderFilter || hit.source.gender === genderFilter) &&
                       (!selectedRegion || clubRegion === selectedRegion);
            };

            const combinedData = {
                upComing: dataUpComing.hits.filter(filterFn),
                inProgress: dataInProgress.hits.filter(filterFn)
            };

            document.getElementById("not_login_user").innerHTML = updateHtml(combinedData);
        });

        $('.custom-in_progress').hide();
        return;
    }

    // ================= ALL =================
    if (eventStateValue === '') {
        const urlInProgress = 'https://api.utrsports.net/v2/search/proTennisTour?top=40&skip=0&utrType=verified&utrTeamType=doubles&sort=eventSchedule.eventStartUtc%3Adesc&showInProgressEvents=true&searchOrigin=searchPage';

        setTimeout(() => {
            fetch(urlInProgress)
                .then(r => r.json())
                .then(data => {
                    const filtered = data.hits.filter(hit => {
                        const clubRegion = hit.source.club.name.split(' - ')[1];
                        return (!genderFilter || hit.source.gender === genderFilter) &&
                               (!selectedRegion || clubRegion === selectedRegion);
                    });

                    const html = updateHtml({ inProgress: filtered, upComing: [] });
                    document.getElementById("not_login_user").innerHTML += html;
                });
        }, 2000);

        $('.custom-in_progress').show();
        $('#rangeDateTypeSelect').show();
        return;
    }

    // ================= OTHERS =================
    $('.custom-in_progress').show();
    $('#rangeDateTypeSelect').toggle(eventStateValue !== 'registration_closed');
}


  
window.addEventListener('load', () => {
    const { tab, region } = getQueryParams();

    // ----- TAB -----
    if (tab === 'completed') {
        $('#rangeDateTypeSelect').val('1').change();
        $('#eventStateSelect').val('completed').change();
    }
    else if (tab === 'registrationclosed') {
        $('#eventStateSelect').val('registration_closed').change();
    }
    else if (tab === 'inprogress') {
        $('#eventStateSelect').val('in_progress').change();
    }
    else {
        $('#eventStateSelect').val('open_registration').change();
    }

    // ----- REGION -----
    if (region === 'americas') {
        $('#regionSelect').val('Americas').change();
    }
    else if (region === 'europe') {
        $('#regionSelect').val('Europe').change();
    }
    else if (region === 'asiapacific') {
        $('#regionSelect').val('Asia & Pacific').change();
    }

    checkInProgress();
});

eventStateSelect.addEventListener('change', checkInProgress);
buttonGender.addEventListener('change', checkInProgress);
buttonRegion.addEventListener('change', checkInProgress);
  
  function updateHtml(data) {
    let customHtml = '';
    let dataUpComing = data.upComing || [];
    let dataInProgress = data.inProgress || [];
    if (dataInProgress.length > 0) {
        customHtml += '<h3 class="month-title text-uppercase gotham-medium fst-italic font-sm-12 min-w-lg-180 min-w-sm-160 mb-0 custom-margin-bottom" style="color: #fff;">In Progress</h3>';
        customHtml += '<div class="grid container-wrap grid--1-col grid--1-col-tablet grid--3-col-desktop d-flex align-items-center pt-lg-2 pb-lg-2 clear-both">';
        
        dataInProgress.forEach(dataHits => {
            let customName = dataHits.source.name;
            let customId = dataHits.source.id;
            let customClub = dataHits.source.club.name;
            let customLocation = dataHits.source.eventLocations[0].display;
            let customEventStartDate = dataHits.source.eventSchedule.eventStartDate;
            let customEventEndDate = dataHits.source.eventSchedule.eventEndDate;
            let customEventStartMonth = dataHits.source.eventSchedule.eventStartMonth;
            let customEventEndMonth = dataHits.source.eventSchedule.eventEndMonth;
            let customOutdoor = dataHits.source.eventDivisions && dataHits.source.eventDivisions[0].environments.length > 0 ? dataHits.source.eventDivisions[0].environments[0].label : '';
            let customHard = dataHits.source.eventDivisions && dataHits.source.eventDivisions[0].surfaces.length > 0 ? dataHits.source.eventDivisions[0].surfaces[0].label : '';
            let customEventRegButtonTitle = 'View';

            customHtml += '<div class="grid__item box-container"><div class="blue-teal-gradient-bg min-h-260 border-radius-lg-3 border-radius-sm-3 custom-m-height-mobile"><div class="custom-position feature-card-box fs-p-2"><div class="d-flex justify-content-between mb-1"><div><h4 class="fs-sm-14">' + customName + '</h4><p class="gotham-medium font-lg-14 font-sm-13 lh-sm-normal fs-mt-0">' + customClub + '</p></div>';
            customHtml += '<a href="https://www.amazon.com/gp/video/storefront/ref=atv_me_pvs_c_hvqwaq_11_smr?contentType=tournament&contentId=amzn1.dv.icid.a7897353-fd02-4669-b996-4866f0c19710" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0690/8071/1488/files/prime-video.png?v=1673424280" width="36" height="36"></a>';
            customHtml += '</div> <div class="d-flex align-items-center contact-icon"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00039 13.5812C6.37907 13.5812 7.85934 12.4999 9.0389 11.1583C10.6113 9.37123 11.5691 7.3766 11.5691 5.4812C11.5691 2.48116 9.1037 0.418701 6.00039 0.418701C2.89708 0.418701 0.431641 2.48116 0.431641 5.4812C0.431641 7.3847 1.38947 9.37933 2.96188 11.1644C4.14043 12.5029 5.6207 13.5812 6.00039 13.5812ZM6.00039 8.9237C5.14109 8.9237 4.31698 8.58235 3.70936 7.97473C3.10175 7.36711 2.76039 6.543 2.76039 5.6837C2.76039 4.8244 3.10175 4.00029 3.70936 3.39268C4.31698 2.78506 5.14109 2.4437 6.00039 2.4437C6.85969 2.4437 7.6838 2.78506 8.29142 3.39268C8.89903 4.00029 9.24039 4.8244 9.24039 5.6837C9.24039 6.543 8.89903 7.36711 8.29142 7.97473C7.6838 8.58235 6.85969 8.9237 6.00039 8.9237Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + customLocation + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.35007 15.6425C3.98471 15.6425 3.67183 15.5125 3.41142 15.2526C3.15146 14.9922 3.02148 14.6793 3.02148 14.3139V5.01385C3.02148 4.64849 3.15146 4.33583 3.41142 4.07587C3.67183 3.81547 3.98471 3.68527 4.35007 3.68527H5.01436V2.35669H6.34294V3.68527H11.6573V2.35669H12.9859V3.68527H13.6501C14.0155 3.68527 14.3284 3.81547 14.5888 4.07587C14.8487 4.33583 14.9787 4.64849 14.9787 5.01385V14.3139C14.9787 14.6793 14.8487 14.9922 14.5888 15.2526C14.3284 15.5125 14.0155 15.6425 13.6501 15.6425H4.35007ZM4.35007 14.3139H13.6501V7.67102H4.35007V14.3139ZM6.34203 13.0078C6.15381 13.0078 5.99593 12.944 5.86839 12.8165C5.74129 12.6894 5.67773 12.5317 5.67773 12.3435C5.67773 12.1553 5.74129 11.9974 5.86839 11.8699C5.99593 11.7427 6.15381 11.6792 6.34203 11.6792C6.53024 11.6792 6.68812 11.7427 6.81567 11.8699C6.94277 11.9974 7.00632 12.1553 7.00632 12.3435C7.00632 12.5317 6.94277 12.6894 6.81567 12.8165C6.68812 12.944 6.53024 13.0078 6.34203 13.0078ZM8.99919 13.0078C8.81097 13.0078 8.65332 12.944 8.52621 12.8165C8.39867 12.6894 8.3349 12.5317 8.3349 12.3435C8.3349 12.1553 8.39867 11.9974 8.52621 11.8699C8.65332 11.7427 8.81097 11.6792 8.99919 11.6792C9.18741 11.6792 9.34529 11.7427 9.47283 11.8699C9.59993 11.9974 9.66348 12.1553 9.66348 12.3435C9.66348 12.5317 9.59993 12.6894 9.47283 12.8165C9.34529 12.944 9.18741 13.0078 8.99919 13.0078ZM11.6564 13.0078C11.4681 13.0078 11.3105 12.944 11.1834 12.8165C11.0558 12.6894 10.9921 12.5317 10.9921 12.3435C10.9921 12.1553 11.0558 11.9974 11.1834 11.8699C11.3105 11.7427 11.4681 11.6792 11.6564 11.6792C11.8446 11.6792 12.0022 11.7427 12.1293 11.8699C12.2569 11.9974 12.3206 12.1553 12.3206 12.3435C12.3206 12.5317 12.2569 12.6894 12.1293 12.8165C12.0022 12.944 11.8446 13.0078 11.6564 13.0078ZM5.86839 10.137C5.99593 10.2646 6.15381 10.3283 6.34203 10.3283C6.53024 10.3283 6.68812 10.2646 6.81567 10.137C6.94277 10.0099 7.00632 9.85226 7.00632 9.66405C7.00632 9.47583 6.94277 9.31795 6.81567 9.19041C6.68812 9.06331 6.53024 8.99976 6.34203 8.99976C6.15381 8.99976 5.99593 9.06331 5.86839 9.19041C5.74129 9.31795 5.67773 9.47583 5.67773 9.66405C5.67773 9.85226 5.74129 10.0099 5.86839 10.137ZM8.52621 10.137C8.65332 10.2646 8.81097 10.3283 8.99919 10.3283C9.18741 10.3283 9.34529 10.2646 9.47283 10.137C9.59993 10.0099 9.66348 9.85226 9.66348 9.66405C9.66348 9.47583 9.59993 9.31795 9.47283 9.19041C9.34529 9.06331 9.18741 8.99976 8.99919 8.99976C8.81097 8.99976 8.65332 9.06331 8.52621 9.19041C8.39867 9.31795 8.3349 9.47583 8.3349 9.66405C8.3349 9.85226 8.39867 10.0099 8.52621 10.137ZM11.1834 10.137C11.3105 10.2646 11.4681 10.3283 11.6564 10.3283C11.8446 10.3283 12.0022 10.2646 12.1293 10.137C12.2569 10.0099 12.3206 9.85226 12.3206 9.66405C12.3206 9.47583 12.2569 9.31795 12.1293 9.19041C12.0022 9.06331 11.8446 8.99976 11.6564 8.99976C11.4681 8.99976 11.3105 9.06331 11.1834 9.19041C11.0558 9.31795 10.9921 9.47583 10.9921 9.66405C10.9921 9.85226 11.0558 10.0099 11.1834 10.137Z" fill="black"></path></svg><span class=" font-lg-13 font-sm-13 gotham-medium">' + customEventStartMonth + ' ' + customEventStartDate + ' - ' + customEventEndMonth + ' ' + customEventEndDate + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68068 10.0835C7.26379 10.8023 7.80656 11.4698 8.364 12.1519C8.64272 11.6825 8.64638 11.6128 8.47768 10.5309H9.42386V12.0895C9.48988 12.1152 9.55589 12.1372 9.6219 12.1629C10.1097 11.5578 10.6194 10.9673 11.0705 10.3365C11.2282 10.1202 11.3492 10.0505 11.5949 10.1055C11.7783 10.1458 11.9727 10.1422 12.1634 10.1458C13.3039 10.1788 14.0924 10.729 14.5912 11.7448C15.376 13.3474 15.0679 14.0809 13.3443 14.5687C11.7453 15.0198 10.0987 15.1078 8.45935 15.0234C7.1611 14.9537 5.85186 14.8181 4.59029 14.532C2.95464 14.1616 2.65392 13.3731 3.35439 11.8475C3.85681 10.7546 4.6783 10.1642 5.89587 10.1385C6.17458 10.1312 6.44964 10.0982 6.68435 10.0835H6.68068Z" fill="black"></path><path d="M8.99523 2.25C10.8802 2.25 12.0318 3.39055 12.0685 5.27924C12.0721 5.47361 12.1418 5.66798 12.1932 5.85868C12.3399 6.37944 12.2628 6.87454 11.9951 7.33662C11.8448 7.60067 11.6981 7.86839 11.5184 8.11044C11.1663 8.59086 10.8546 9.12263 10.4218 9.5187C9.53433 10.3402 8.4928 10.3219 7.56862 9.53337C7.31558 9.317 7.0772 9.06395 6.89383 8.7889C6.54543 8.2718 6.20437 7.7437 5.92565 7.18626C5.69827 6.72418 5.60292 6.22908 5.8743 5.71199C5.97332 5.52128 5.92565 5.25723 5.94398 5.02619C6.11268 3.24385 7.20556 2.25 8.99523 2.25ZM8.99523 9.65439C9.36196 9.49303 9.76537 9.42335 9.99641 9.18864C10.4365 8.73756 10.7776 8.18745 11.159 7.67769C11.2433 7.56767 11.2947 7.42464 11.401 7.34029C11.8154 6.99923 11.8521 6.46379 11.4744 6.05672C11.4267 6.00537 11.412 5.92836 11.3863 5.86235C11.137 5.23156 10.4622 4.91984 9.76537 4.99685C9.20793 5.05553 8.62482 5.04453 8.07105 4.95284C7.34125 4.83182 6.97818 4.96384 6.68112 5.64964C6.62245 5.78167 6.59677 5.94303 6.50876 6.04571C6.20437 6.39778 6.17869 6.90754 6.45008 7.23761C6.63711 7.46498 6.78381 7.7217 6.96351 7.95641C7.28257 8.37082 7.57229 8.81824 7.95736 9.16297C8.22141 9.40135 8.62116 9.4857 8.99523 9.65439Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + customOutdoor + ' | ' + customHard + '</span></div><div class="custom-d-flex d-flex justify-content-center align-items-center mt-4"><a href="https://app.utrsports.net/events/' + '' + customId + '" target="_blank" class="custom-min-w-sm-145 btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">' + customEventRegButtonTitle + '</a> </div></div></div></div>';
        });
        customHtml += '</div>';
    }
    
    if (dataUpComing.length > 0) {
        customHtml += '<h3 class="month-title text-uppercase gotham-medium fst-italic font-sm-12 min-w-lg-180 min-w-sm-160 mb-0 custom-margin-bottom" style="color: #fff;">UpComing</h3>';
        customHtml += '<div class="grid container-wrap grid--1-col grid--1-col-tablet grid--3-col-desktop d-flex align-items-center pt-lg-2 pb-lg-2 clear-both">';
        dataUpComing.forEach(dataHits => {
            let customName = dataHits.source.name;
            let customId = dataHits.source.id;
            let customClub = dataHits.source.club.name;
            let customLocation = dataHits.source.eventLocations[0].display;
            let customEventStartDate = dataHits.source.eventSchedule.eventStartDate;
            let customEventEndDate = dataHits.source.eventSchedule.eventEndDate;
            let customEventStartMonth = dataHits.source.eventSchedule.eventStartMonth;
            let customEventEndMonth = dataHits.source.eventSchedule.eventEndMonth;
            let customOutdoor = dataHits.source.eventDivisions && dataHits.source.eventDivisions[0].environments.length > 0 ? dataHits.source.eventDivisions[0].environments[0].label : '';
            let customHard = dataHits.source.eventDivisions && dataHits.source.eventDivisions[0].surfaces.length > 0 ? dataHits.source.eventDivisions[0].surfaces[0].label : '';
            let customEventRegButtonTitle = 'View';

            customHtml += '<div class="grid__item box-container"><div class="blue-teal-gradient-bg min-h-260 border-radius-lg-3 border-radius-sm-3 custom-m-height-mobile"><div class="custom-position  feature-card-box fs-p-2"><div class="d-flex justify-content-between mb-1"><div><h4 class="fs-sm-14">' + customName + '</h4><p class="gotham-medium font-lg-14 font-sm-13 lh-sm-normal fs-mt-0">' + customClub + '</p></div>';
            customHtml += '<a href="https://www.amazon.com/gp/video/storefront/ref=atv_me_pvs_c_hvqwaq_11_smr?contentType=tournament&contentId=amzn1.dv.icid.a7897353-fd02-4669-b996-4866f0c19710" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0690/8071/1488/files/prime-video.png?v=1673424280" width="36" height="36"></a>';
            customHtml += '</div> <div class="d-flex align-items-center contact-icon"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00039 13.5812C6.37907 13.5812 7.85934 12.4999 9.0389 11.1583C10.6113 9.37123 11.5691 7.3766 11.5691 5.4812C11.5691 2.48116 9.1037 0.418701 6.00039 0.418701C2.89708 0.418701 0.431641 2.48116 0.431641 5.4812C0.431641 7.3847 1.38947 9.37933 2.96188 11.1644C4.14043 12.5029 5.6207 13.5812 6.00039 13.5812ZM6.00039 8.9237C5.14109 8.9237 4.31698 8.58235 3.70936 7.97473C3.10175 7.36711 2.76039 6.543 2.76039 5.6837C2.76039 4.8244 3.10175 4.00029 3.70936 3.39268C4.31698 2.78506 5.14109 2.4437 6.00039 2.4437C6.85969 2.4437 7.6838 2.78506 8.29142 3.39268C8.89903 4.00029 9.24039 4.8244 9.24039 5.6837C9.24039 6.543 8.89903 7.36711 8.29142 7.97473C7.6838 8.58235 6.85969 8.9237 6.00039 8.9237Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + customLocation + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.35007 15.6425C3.98471 15.6425 3.67183 15.5125 3.41142 15.2526C3.15146 14.9922 3.02148 14.6793 3.02148 14.3139V5.01385C3.02148 4.64849 3.15146 4.33583 3.41142 4.07587C3.67183 3.81547 3.98471 3.68527 4.35007 3.68527H5.01436V2.35669H6.34294V3.68527H11.6573V2.35669H12.9859V3.68527H13.6501C14.0155 3.68527 14.3284 3.81547 14.5888 4.07587C14.8487 4.33583 14.9787 4.64849 14.9787 5.01385V14.3139C14.9787 14.6793 14.8487 14.9922 14.5888 15.2526C14.3284 15.5125 14.0155 15.6425 13.6501 15.6425H4.35007ZM4.35007 14.3139H13.6501V7.67102H4.35007V14.3139ZM6.34203 13.0078C6.15381 13.0078 5.99593 12.944 5.86839 12.8165C5.74129 12.6894 5.67773 12.5317 5.67773 12.3435C5.67773 12.1553 5.74129 11.9974 5.86839 11.8699C5.99593 11.7427 6.15381 11.6792 6.34203 11.6792C6.53024 11.6792 6.68812 11.7427 6.81567 11.8699C6.94277 11.9974 7.00632 12.1553 7.00632 12.3435C7.00632 12.5317 6.94277 12.6894 6.81567 12.8165C6.68812 12.944 6.53024 13.0078 6.34203 13.0078ZM8.99919 13.0078C8.81097 13.0078 8.65332 12.944 8.52621 12.8165C8.39867 12.6894 8.3349 12.5317 8.3349 12.3435C8.3349 12.1553 8.39867 11.9974 8.52621 11.8699C8.65332 11.7427 8.81097 11.6792 8.99919 11.6792C9.18741 11.6792 9.34529 11.7427 9.47283 11.8699C9.59993 11.9974 9.66348 12.1553 9.66348 12.3435C9.66348 12.5317 9.59993 12.6894 9.47283 12.8165C9.34529 12.944 9.18741 13.0078 8.99919 13.0078ZM11.6564 13.0078C11.4681 13.0078 11.3105 12.944 11.1834 12.8165C11.0558 12.6894 10.9921 12.5317 10.9921 12.3435C10.9921 12.1553 11.0558 11.9974 11.1834 11.8699C11.3105 11.7427 11.4681 11.6792 11.6564 11.6792C11.8446 11.6792 12.0022 11.7427 12.1293 11.8699C12.2569 11.9974 12.3206 12.1553 12.3206 12.3435C12.3206 12.5317 12.2569 12.6894 12.1293 12.8165C12.0022 12.944 11.8446 13.0078 11.6564 13.0078ZM5.86839 10.137C5.99593 10.2646 6.15381 10.3283 6.34203 10.3283C6.53024 10.3283 6.68812 10.2646 6.81567 10.137C6.94277 10.0099 7.00632 9.85226 7.00632 9.66405C7.00632 9.47583 6.94277 9.31795 6.81567 9.19041C6.68812 9.06331 6.53024 8.99976 6.34203 8.99976C6.15381 8.99976 5.99593 9.06331 5.86839 9.19041C5.74129 9.31795 5.67773 9.47583 5.67773 9.66405C5.67773 9.85226 5.74129 10.0099 5.86839 10.137ZM8.52621 10.137C8.65332 10.2646 8.81097 10.3283 8.99919 10.3283C9.18741 10.3283 9.34529 10.2646 9.47283 10.137C9.59993 10.0099 9.66348 9.85226 9.66348 9.66405C9.66348 9.47583 9.59993 9.31795 9.47283 9.19041C9.34529 9.06331 9.18741 8.99976 8.99919 8.99976C8.81097 8.99976 8.65332 9.06331 8.52621 9.19041C8.39867 9.31795 8.3349 9.47583 8.3349 9.66405C8.3349 9.85226 8.39867 10.0099 8.52621 10.137ZM11.1834 10.137C11.3105 10.2646 11.4681 10.3283 11.6564 10.3283C11.8446 10.3283 12.0022 10.2646 12.1293 10.137C12.2569 10.0099 12.3206 9.85226 12.3206 9.66405C12.3206 9.47583 12.2569 9.31795 12.1293 9.19041C12.0022 9.06331 11.8446 8.99976 11.6564 8.99976C11.4681 8.99976 11.3105 9.06331 11.1834 9.19041C11.0558 9.31795 10.9921 9.47583 10.9921 9.66405C10.9921 9.85226 11.0558 10.0099 11.1834 10.137Z" fill="black"></path></svg><span class=" font-lg-13 font-sm-13 gotham-medium">' + customEventStartMonth + ' ' + customEventStartDate + ' - ' + customEventEndMonth + ' ' + customEventEndDate + '</span></div><div class="d-flex align-items-center contact-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68068 10.0835C7.26379 10.8023 7.80656 11.4698 8.364 12.1519C8.64272 11.6825 8.64638 11.6128 8.47768 10.5309H9.42386V12.0895C9.48988 12.1152 9.55589 12.1372 9.6219 12.1629C10.1097 11.5578 10.6194 10.9673 11.0705 10.3365C11.2282 10.1202 11.3492 10.0505 11.5949 10.1055C11.7783 10.1458 11.9727 10.1422 12.1634 10.1458C13.3039 10.1788 14.0924 10.729 14.5912 11.7448C15.376 13.3474 15.0679 14.0809 13.3443 14.5687C11.7453 15.0198 10.0987 15.1078 8.45935 15.0234C7.1611 14.9537 5.85186 14.8181 4.59029 14.532C2.95464 14.1616 2.65392 13.3731 3.35439 11.8475C3.85681 10.7546 4.6783 10.1642 5.89587 10.1385C6.17458 10.1312 6.44964 10.0982 6.68435 10.0835H6.68068Z" fill="black"></path><path d="M8.99523 2.25C10.8802 2.25 12.0318 3.39055 12.0685 5.27924C12.0721 5.47361 12.1418 5.66798 12.1932 5.85868C12.3399 6.37944 12.2628 6.87454 11.9951 7.33662C11.8448 7.60067 11.6981 7.86839 11.5184 8.11044C11.1663 8.59086 10.8546 9.12263 10.4218 9.5187C9.53433 10.3402 8.4928 10.3219 7.56862 9.53337C7.31558 9.317 7.0772 9.06395 6.89383 8.7889C6.54543 8.2718 6.20437 7.7437 5.92565 7.18626C5.69827 6.72418 5.60292 6.22908 5.8743 5.71199C5.97332 5.52128 5.92565 5.25723 5.94398 5.02619C6.11268 3.24385 7.20556 2.25 8.99523 2.25ZM8.99523 9.65439C9.36196 9.49303 9.76537 9.42335 9.99641 9.18864C10.4365 8.73756 10.7776 8.18745 11.159 7.67769C11.2433 7.56767 11.2947 7.42464 11.401 7.34029C11.8154 6.99923 11.8521 6.46379 11.4744 6.05672C11.4267 6.00537 11.412 5.92836 11.3863 5.86235C11.137 5.23156 10.4622 4.91984 9.76537 4.99685C9.20793 5.05553 8.62482 5.04453 8.07105 4.95284C7.34125 4.83182 6.97818 4.96384 6.68112 5.64964C6.62245 5.78167 6.59677 5.94303 6.50876 6.04571C6.20437 6.39778 6.17869 6.90754 6.45008 7.23761C6.63711 7.46498 6.78381 7.7217 6.96351 7.95641C7.28257 8.37082 7.57229 8.81824 7.95736 9.16297C8.22141 9.40135 8.62116 9.4857 8.99523 9.65439Z" fill="black"></path></svg><span class="font-lg-13 font-sm-13 gotham-medium">' + customOutdoor + ' | ' + customHard + '</span></div><div class="custom-d-flex d-flex justify-content-center align-items-center mt-4"><a href="https://app.utrsports.net/events/' + '' + customId + '" target="_blank" class="custom-min-w-sm-145 btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">' + customEventRegButtonTitle + '</a> </div></div></div></div>';
        });
        customHtml += '</div>';
    }
    return customHtml;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-junior-national-search-filter"] && !Shopify.designMode) return;
  try {
    

  let tour = 'Junior Regionals';
  let eventState = 'open_registration';
  let teamType = '';
  let gender = '';
  let region = '';
  let range = '';
  let range1 = '';
  let range2 = '';
  let currentYear = '2023';
  let searchQuery = '';
  let currentItem = 3;
  
  let loadMoreBtn = document.querySelector('.ut-jn-api-load-more-btn');
  let searchInputElement = document.querySelector('.ut-jn-api-searchInput');
  let searchBtn = document.querySelector('.ut-jn-api-searchButton');
  let shareLink = document.querySelector('.share-link');
  
  //Fetch all events 
  fetchEvents();

  //Search Functionality
  $('#ut-jn-api-searchInput').keypress(function (e) {                                       
       if (e.which == 13) {
         e.preventDefault();
         
         //do something    
         searchQuery = document.getElementById('ut-jn-api-searchInput').value;
         fetchEvents();

       }
  });  
  
  const inputHandler = function(e) {
    searchQuery = e.target.value;
    console.log(searchQuery);
  }
  searchInputElement.addEventListener('input', inputHandler);
  
  //Search Functionality
  searchBtn.onclick = () => {
    searchQuery = document.getElementById('ut-jn-api-searchButton').value;
    fetchEvents();
  }


  //Share Functionality
  function shareClicked() {
  
    console.log('shareClicked');
    if (navigator.share) {
      navigator.share({
        title: 'WebShare API Demo',
        url: 'https://codepen.io/ayoisaiah/pen/YbNazJ'
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(console.error);    
    } else {
      console.log('Browser not supporting Web Share!');
    }

  }
   
  //Load More Functionality
  loadMoreBtn.onclick = () => {
    
    let boxes = [...document.querySelectorAll('.ut-jn-api-container-wrap .ut-jn-api-box-container')];
    
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].style.display = "inline-block";
    }
              
    loadMoreBtn.style.display = "none";
    
  }

  function displayLoadMore(isDisplay) {
    if(isDisplay) {
      loadMoreBtn.style.display = "inline-block";
    } else {
      loadMoreBtn.style.display = "none";
    }
  }
  
  //Filter by gender
  document.getElementById("ut-jn-api-genderSelect").onchange = function() {selectGender()};

  function selectGender() {
    gender = document.getElementById("ut-jn-api-genderSelect").value;
    fetchEvents();
  }
 
  //Filter by event state
  document.getElementById("ut-jn-api-eventStatusSelect").onchange = function() {selectEventState()};

  function selectEventState() {
    eventState = document.getElementById("ut-jn-api-eventStatusSelect").value;
    fetchEvents();
  }

  /* Comment | No Api available for team type select singles & doubles
  //Filter by team type
  document.getElementById("teamTypeSelect").onchange = function() {selectTeamType()};
  function selectTeamType() {
    teamType = document.getElementById("teamTypeSelect").value;
    fetchEvents();
  }
  */
  
  //Filter by team type
  document.getElementById("ut-jn-api-regionSelect").onchange = function() {selectRegion()};

  function selectRegion() {
    region = document.getElementById("ut-jn-api-regionSelect").value;
    fetchEvents();
  }


  //Filter by team type
  document.getElementById("ut-jn-api-rangeSelect").onchange = function() {selectRange()};

  function selectRange() {
    range = document.getElementById("ut-jn-api-rangeSelect").value;
    if (range) {
      range1 = 'eventSchedule.eventStartUtc>='+range+'/01/'+currentYear;
      range2 = 'eventSchedule.eventStartUtc<='+range+'/'+getDaysInMonth(range,currentYear)+'/'+currentYear; 
    }    
    
    fetchEvents();
  }

  //Fetch Events 
  function fetchEvents() {
    
    var grid_element = document.getElementById("ut-jn-api-grid");
    grid_element.innerHTML="Fetching....";
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'  
    };

    let fetchEventURL =  'https://api.utrsports.net/v2/search/events?tours='+tour+'&eventState='+eventState+'&top=250&skip=0'+(searchQuery != "" ? '&query='+searchQuery : "")+(gender != "" ? '&genders='+gender : "")+(teamType != "" ? '&teamType='+teamType : "")+(range != "" ? '&range='+range1+'&range='+range2 : "");
          
    fetch(fetchEventURL, requestOptions)
    .then(response => response.json())
    .then((result) => {
      let data="";
      let i=1;
      let cCount = 0;
      result.hits.map((values)=>{
        
        // var name = values.source.name.substring(1, 47);
        var id =  values.source.id; 
        var name = values.source.name;
        var club = values.source.club.name;
        var location = values.source.eventLocations[0].display;
        var eventStartDate = values.source.eventSchedule.eventStartDate;
        var eventEndDate = values.source.eventSchedule.eventEndDate;
        var eventStartMonth = values.source.eventSchedule.eventStartMonth;
        var eventEndMonth = values.source.eventSchedule.eventEndMonth;
        var gender = values.source.gender; 
        var outdoor = values.source.eventDivisions[0].environments[0].label; 
        var hard = values.source.eventDivisions[0].surfaces[0].label; 
        var addToGrid = false;
        if (region) {
          if (club.includes(region)) {
            addToGrid = true;
          }
        } else {
            addToGrid = true;
        }  

        if (club.includes("Junior Nationals")) {
          addToGrid = true;
        } else {
          addToGrid = false;
        }

        if(addToGrid) {
          
         cCount += 1;
          
         data += '<div class="grid__item ut-jn-api-box-container">' + 
'        <div class="blue-teal-gradient-bg border-radius-lg-3 border-radius-sm-3 min-h-260">' + 
'           <div class="feature-card-box fs-p-2">' + 
'             <div class="d-flex justify-content-between mb-1">' + 
'               <div>' + 
'                 <h4 class="fs-sm-14">'+name+'</h4>' + 
'                 <p class="gotham-medium font-lg-14 font-sm-13 lh-sm-normal fs-mt-0">'+club+'</p>' + 
'               </div>  ' + 
'               <div>' + 
'                  <!--Hide Share-- <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'<path d="M20 11.5716C21.3807 11.5716 22.5 10.4203 22.5 9.00014C22.5 7.57998 21.3807 6.42871 20 6.42871C18.6193 6.42871 17.5 7.57998 17.5 9.00014C17.5 10.4203 18.6193 11.5716 20 11.5716Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M10 17.5717C11.3807 17.5717 12.5 16.4204 12.5 15.0003C12.5 13.5801 11.3807 12.4288 10 12.4288C8.61929 12.4288 7.5 13.5801 7.5 15.0003C7.5 16.4204 8.61929 17.5717 10 17.5717Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M20 23.5714C21.3807 23.5714 22.5 22.4202 22.5 21C22.5 19.5799 21.3807 18.4286 20 18.4286C18.6193 18.4286 17.5 19.5799 17.5 21C17.5 22.4202 18.6193 23.5714 20 23.5714Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M12.1582 16.2944L17.8499 19.7059" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M17.8415 10.2943L12.1582 13.7057" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'</svg> --Hide Share-->' + 
'               </div>' + 
'             </div> ' + 
'             <div class="d-flex align-items-center contact-icon">' + 
'          <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'          <path d="M6.00039 13.5812C6.37907 13.5812 7.85934 12.4999 9.0389 11.1583C10.6113 9.37123 11.5691 7.3766 11.5691 5.4812C11.5691 2.48116 9.1037 0.418701 6.00039 0.418701C2.89708 0.418701 0.431641 2.48116 0.431641 5.4812C0.431641 7.3847 1.38947 9.37933 2.96188 11.1644C4.14043 12.5029 5.6207 13.5812 6.00039 13.5812ZM6.00039 8.9237C5.14109 8.9237 4.31698 8.58235 3.70936 7.97473C3.10175 7.36711 2.76039 6.543 2.76039 5.6837C2.76039 4.8244 3.10175 4.00029 3.70936 3.39268C4.31698 2.78506 5.14109 2.4437 6.00039 2.4437C6.85969 2.4437 7.6838 2.78506 8.29142 3.39268C8.89903 4.00029 9.24039 4.8244 9.24039 5.6837C9.24039 6.543 8.89903 7.36711 8.29142 7.97473C7.6838 8.58235 6.85969 8.9237 6.00039 8.9237Z" fill="black"></path>' + 
'          </svg>' + 
'          <span class="font-lg-13 font-sm-13 gotham-medium">'+location+'</span></div>' + 
'                       <div class="d-flex align-items-center contact-icon">' + 
'          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.35007 15.6425C3.98471 15.6425 3.67183 15.5125 3.41142 15.2526C3.15146 14.9922 3.02148 14.6793 3.02148 14.3139V5.01385C3.02148 4.64849 3.15146 4.33583 3.41142 4.07587C3.67183 3.81547 3.98471 3.68527 4.35007 3.68527H5.01436V2.35669H6.34294V3.68527H11.6573V2.35669H12.9859V3.68527H13.6501C14.0155 3.68527 14.3284 3.81547 14.5888 4.07587C14.8487 4.33583 14.9787 4.64849 14.9787 5.01385V14.3139C14.9787 14.6793 14.8487 14.9922 14.5888 15.2526C14.3284 15.5125 14.0155 15.6425 13.6501 15.6425H4.35007ZM4.35007 14.3139H13.6501V7.67102H4.35007V14.3139ZM6.34203 13.0078C6.15381 13.0078 5.99593 12.944 5.86839 12.8165C5.74129 12.6894 5.67773 12.5317 5.67773 12.3435C5.67773 12.1553 5.74129 11.9974 5.86839 11.8699C5.99593 11.7427 6.15381 11.6792 6.34203 11.6792C6.53024 11.6792 6.68812 11.7427 6.81567 11.8699C6.94277 11.9974 7.00632 12.1553 7.00632 12.3435C7.00632 12.5317 6.94277 12.6894 6.81567 12.8165C6.68812 12.944 6.53024 13.0078 6.34203 13.0078ZM8.99919 13.0078C8.81097 13.0078 8.65332 12.944 8.52621 12.8165C8.39867 12.6894 8.3349 12.5317 8.3349 12.3435C8.3349 12.1553 8.39867 11.9974 8.52621 11.8699C8.65332 11.7427 8.81097 11.6792 8.99919 11.6792C9.18741 11.6792 9.34529 11.7427 9.47283 11.8699C9.59993 11.9974 9.66348 12.1553 9.66348 12.3435C9.66348 12.5317 9.59993 12.6894 9.47283 12.8165C9.34529 12.944 9.18741 13.0078 8.99919 13.0078ZM11.6564 13.0078C11.4681 13.0078 11.3105 12.944 11.1834 12.8165C11.0558 12.6894 10.9921 12.5317 10.9921 12.3435C10.9921 12.1553 11.0558 11.9974 11.1834 11.8699C11.3105 11.7427 11.4681 11.6792 11.6564 11.6792C11.8446 11.6792 12.0022 11.7427 12.1293 11.8699C12.2569 11.9974 12.3206 12.1553 12.3206 12.3435C12.3206 12.5317 12.2569 12.6894 12.1293 12.8165C12.0022 12.944 11.8446 13.0078 11.6564 13.0078ZM5.86839 10.137C5.99593 10.2646 6.15381 10.3283 6.34203 10.3283C6.53024 10.3283 6.68812 10.2646 6.81567 10.137C6.94277 10.0099 7.00632 9.85226 7.00632 9.66405C7.00632 9.47583 6.94277 9.31795 6.81567 9.19041C6.68812 9.06331 6.53024 8.99976 6.34203 8.99976C6.15381 8.99976 5.99593 9.06331 5.86839 9.19041C5.74129 9.31795 5.67773 9.47583 5.67773 9.66405C5.67773 9.85226 5.74129 10.0099 5.86839 10.137ZM8.52621 10.137C8.65332 10.2646 8.81097 10.3283 8.99919 10.3283C9.18741 10.3283 9.34529 10.2646 9.47283 10.137C9.59993 10.0099 9.66348 9.85226 9.66348 9.66405C9.66348 9.47583 9.59993 9.31795 9.47283 9.19041C9.34529 9.06331 9.18741 8.99976 8.99919 8.99976C8.81097 8.99976 8.65332 9.06331 8.52621 9.19041C8.39867 9.31795 8.3349 9.47583 8.3349 9.66405C8.3349 9.85226 8.39867 10.0099 8.52621 10.137ZM11.1834 10.137C11.3105 10.2646 11.4681 10.3283 11.6564 10.3283C11.8446 10.3283 12.0022 10.2646 12.1293 10.137C12.2569 10.0099 12.3206 9.85226 12.3206 9.66405C12.3206 9.47583 12.2569 9.31795 12.1293 9.19041C12.0022 9.06331 11.8446 8.99976 11.6564 8.99976C11.4681 8.99976 11.3105 9.06331 11.1834 9.19041C11.0558 9.31795 10.9921 9.47583 10.9921 9.66405C10.9921 9.85226 11.0558 10.0099 11.1834 10.137Z" fill="black"></path>' + 
'          </svg>' + 
'          <span class=" font-lg-13 font-sm-13 gotham-medium">'+eventStartMonth+' '+eventStartDate+' - '+eventEndMonth+' '+eventEndDate+'</span></div>' + 
'                       <div class="d-flex align-items-center contact-icon">' + 
'          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'          <path d="M6.68068 10.0835C7.26379 10.8023 7.80656 11.4698 8.364 12.1519C8.64272 11.6825 8.64638 11.6128 8.47768 10.5309H9.42386V12.0895C9.48988 12.1152 9.55589 12.1372 9.6219 12.1629C10.1097 11.5578 10.6194 10.9673 11.0705 10.3365C11.2282 10.1202 11.3492 10.0505 11.5949 10.1055C11.7783 10.1458 11.9727 10.1422 12.1634 10.1458C13.3039 10.1788 14.0924 10.729 14.5912 11.7448C15.376 13.3474 15.0679 14.0809 13.3443 14.5687C11.7453 15.0198 10.0987 15.1078 8.45935 15.0234C7.1611 14.9537 5.85186 14.8181 4.59029 14.532C2.95464 14.1616 2.65392 13.3731 3.35439 11.8475C3.85681 10.7546 4.6783 10.1642 5.89587 10.1385C6.17458 10.1312 6.44964 10.0982 6.68435 10.0835H6.68068Z" fill="black"></path>' + 
'          <path d="M8.99523 2.25C10.8802 2.25 12.0318 3.39055 12.0685 5.27924C12.0721 5.47361 12.1418 5.66798 12.1932 5.85868C12.3399 6.37944 12.2628 6.87454 11.9951 7.33662C11.8448 7.60067 11.6981 7.86839 11.5184 8.11044C11.1663 8.59086 10.8546 9.12263 10.4218 9.5187C9.53433 10.3402 8.4928 10.3219 7.56862 9.53337C7.31558 9.317 7.0772 9.06395 6.89383 8.7889C6.54543 8.2718 6.20437 7.7437 5.92565 7.18626C5.69827 6.72418 5.60292 6.22908 5.8743 5.71199C5.97332 5.52128 5.92565 5.25723 5.94398 5.02619C6.11268 3.24385 7.20556 2.25 8.99523 2.25ZM8.99523 9.65439C9.36196 9.49303 9.76537 9.42335 9.99641 9.18864C10.4365 8.73756 10.7776 8.18745 11.159 7.67769C11.2433 7.56767 11.2947 7.42464 11.401 7.34029C11.8154 6.99923 11.8521 6.46379 11.4744 6.05672C11.4267 6.00537 11.412 5.92836 11.3863 5.86235C11.137 5.23156 10.4622 4.91984 9.76537 4.99685C9.20793 5.05553 8.62482 5.04453 8.07105 4.95284C7.34125 4.83182 6.97818 4.96384 6.68112 5.64964C6.62245 5.78167 6.59677 5.94303 6.50876 6.04571C6.20437 6.39778 6.17869 6.90754 6.45008 7.23761C6.63711 7.46498 6.78381 7.7217 6.96351 7.95641C7.28257 8.37082 7.57229 8.81824 7.95736 9.16297C8.22141 9.40135 8.62116 9.4857 8.99523 9.65439Z" fill="black"></path>' + 
'          </svg>' + 
'          <span class="font-lg-13 font-sm-13 gotham-medium">'+gender+'</span></div>' + 
'          <div class="d-flex justify-content-center align-items-center mt-4">' + 
'              <a href="https://app.utrsports.net/events/'+id+'" target="_blank" class="btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">Register</a> ' + 
'          </div>' + 
'           </div>' + 
'        </div>' + 
'      </div>';  

        }
         
        i=i+1;

        if (cCount>6){
          displayLoadMore(true);
        } else {
          displayLoadMore(false);
        }

      });
      
      grid_element.innerHTML=data;
      
    })
    .catch(error => console.log('error', error));    
  }

  //Helper functions
  var getDaysInMonth = function(month,year) {
    // Here January is 1 based
    //Day 0 is the last day in the previous month
   return new Date(year, month, 0).getDate();
  // Here January is 0 based
  // return new Date(year, month+1, 0).getDate();
  };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-junior-regional-search-filter"] && !Shopify.designMode) return;
  try {
    

  let tour = 'Junior Regionals';
  let eventState = 'open_registration';
  let teamType = '';
  let gender = '';
  let region = '';

  const date = new Date(); 
  let dayToday = date.getDate();
  let monthToday = date.getMonth() + 1;
  let currentYear = date.getFullYear(); 

  let range = '';
  let range1 = 'eventSchedule.eventStartUtc<='+dayToday+'/'+monthToday+'/'+currentYear;
  let range2 = 'eventSchedule.eventStartUtc>='+dayToday+'/'+monthToday+'/'+currentYear; 
  
  let searchQuery = '';
  let currentItem = 0;
  let loadMoreBtn = document.querySelector('.ut-jr-api-load-more-btn');
  let searchInputElement = document.querySelector('.ut-jr-api-searchInput');
  let searchBtn = document.querySelector('.ut-jr-api-searchButton');
  let shareLink = document.querySelector('.share-link');
  
  //Fetch all events 
  fetchEvents();

  //Search Functionality
  $('#ut-jr-api-searchInput').keypress(function (e) {                                       
       if (e.which == 13) {
         e.preventDefault();
         
         //do something    
         searchQuery = document.getElementById('ut-jr-api-searchInput').value;
         fetchEvents();

       }
  });  
  
  const inputHandler = function(e) {
    searchQuery = e.target.value;
    console.log(searchQuery);
  }
  searchInputElement.addEventListener('input', inputHandler);
  
  //Search Functionality
  searchBtn.onclick = () => {
    searchQuery = document.getElementById('ut-jr-api-searchButton').value;
    fetchEvents();
  }


  //Share Functionality
  function shareClicked() {
  
    console.log('shareClicked');
    if (navigator.share) {
      navigator.share({
        title: 'WebShare API Demo',
        url: 'https://codepen.io/ayoisaiah/pen/YbNazJ'
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(console.error);    
    } else {
      console.log('Browser not supporting Web Share!');
    }

  }
  
  
  //Load More Functionality
  loadMoreBtn.onclick = () => {
    
    let boxes = [...document.querySelectorAll('.ut-jr-api-container-wrap .ut-jr-api-box-container')];
    
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].style.display = "inline-block";
    }
            
    loadMoreBtn.style.display = "none";
    
  }

  //Filter by gender
  document.getElementById("ut-jr-api-genderSelect").onchange = function() {selectGender()};

  function selectGender() {
    gender = document.getElementById("ut-jr-api-genderSelect").value;
    fetchEvents();
  }
 
  //Filter by event state
  document.getElementById("ut-jr-api-eventStatusSelect").onchange = function() {selectEventState()};

  function selectEventState() {
    eventState = document.getElementById("ut-jr-api-eventStatusSelect").value;
    fetchEvents();
  }

  /* Comment | No Api available for team type select singles & doubles
  //Filter by team type
  document.getElementById("teamTypeSelect").onchange = function() {selectTeamType()};
  function selectTeamType() {
    teamType = document.getElementById("teamTypeSelect").value;
    fetchEvents();
  }
  */
  
  //Filter by team type
  document.getElementById("ut-jr-api-regionSelect").onchange = function() {selectRegion()};

  function selectRegion() {
    region = document.getElementById("ut-jr-api-regionSelect").value;
    fetchEvents();
  }


  //Filter by team type
  document.getElementById("ut-jr-api-rangeSelect").onchange = function() {selectRange()};

  function selectRange() {
    range = document.getElementById("ut-jr-api-rangeSelect").value;
    if (range) {
      range1 = 'eventSchedule.eventStartUtc>='+range+'/01/'+currentYear;
      range2 = 'eventSchedule.eventStartUtc<='+range+'/'+getDaysInMonth(range,currentYear)+'/'+currentYear; 
    }    
    
    fetchEvents();
  }

  //Fetch Events 
  function fetchEvents() {
     
    var grid_element = document.getElementById("ut-jr-api-grid");
    grid_element.innerHTML="Fetching....";

      var currentDate = new Date();
      var formattedCurrentDate = currentDate.toISOString().split('T')[0];

     var addToGrid = false;
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'  
    };

    let fetchEventURL =  'https://api.utrsports.net/v2/search/events?tours='+tour+'&eventState='+eventState+'&top=250&skip=0'+(searchQuery != "" ? '&query='+searchQuery : "")+(gender != "" ? '&genders='+gender : "")+(teamType != "" ? '&teamType='+teamType : "")+(range != "" ? '&range='+range1+'&range='+range2 : "");
          
    fetch(fetchEventURL, requestOptions)
    .then(response => response.json())
    .then((result) => {
      let data="";
      let i=0;     
console.log("data", result);
      result.hits.map((values)=>{        
        // var name = values.source.name.substring(1, 47);
        var id =  values.source.id; 
        var name = values.source.name;
        var club = values.source.club.name;
        var regCheck = (values.source.eventRegions[0] && values.source.eventRegions[0].region) ? values.source.eventRegions[0].region.value : null;
        var location = values.source.eventLocations[0].display;
        var eventRegEndFullDate = values.source.eventSchedule.registrationEndUtc;
        var eventStartDate = values.source.eventSchedule.eventStartDate;
        var eventEndDate = values.source.eventSchedule.eventEndDate;
        var eventStartMonth = values.source.eventSchedule.eventStartMonth;
        var eventEndMonth = values.source.eventSchedule.eventEndMonth;
        var gender = values.source.gender; 
        var outdoor = values.source.eventDivisions[0].environments[0].label; 
        var hard = values.source.eventDivisions[0].surfaces[0].label; 
       
        var formattedRegEndDate = new Date(eventRegEndFullDate).toISOString().split('T')[0];
  
        if (region) {
          if (regCheck == region) {
            addToGrid = true;
          }
        } else {
            addToGrid = true;
        }          

        if(addToGrid) {
         data += '<div class="grid__item ut-jr-api-box-container">' + 
'        <div class="blue-teal-gradient-bg border-radius-lg-3 border-radius-sm-3 min-h-260">' + 
'           <div class="feature-card-box fs-p-2">' + 
'             <div class="d-flex justify-content-between mb-1">' + 
'               <div>' + 
'                 <h4 class="fs-sm-14">'+name+'</h4>' + 
'                 <p class="gotham-medium font-lg-14 font-sm-13 lh-sm-normal fs-mt-0">'+club+'</p>' + 
'               </div>  ' + 
'               <div>' + 
'                  <!--Hide Share-- <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'<path d="M20 11.5716C21.3807 11.5716 22.5 10.4203 22.5 9.00014C22.5 7.57998 21.3807 6.42871 20 6.42871C18.6193 6.42871 17.5 7.57998 17.5 9.00014C17.5 10.4203 18.6193 11.5716 20 11.5716Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M10 17.5717C11.3807 17.5717 12.5 16.4204 12.5 15.0003C12.5 13.5801 11.3807 12.4288 10 12.4288C8.61929 12.4288 7.5 13.5801 7.5 15.0003C7.5 16.4204 8.61929 17.5717 10 17.5717Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M20 23.5714C21.3807 23.5714 22.5 22.4202 22.5 21C22.5 19.5799 21.3807 18.4286 20 18.4286C18.6193 18.4286 17.5 19.5799 17.5 21C17.5 22.4202 18.6193 23.5714 20 23.5714Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M12.1582 16.2944L17.8499 19.7059" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'<path d="M17.8415 10.2943L12.1582 13.7057" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' + 
'</svg> --Hide Share-->' + 
'               </div>' + 
'             </div> ' + 
'             <div class="d-flex align-items-center contact-icon">' + 
'          <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'          <path d="M6.00039 13.5812C6.37907 13.5812 7.85934 12.4999 9.0389 11.1583C10.6113 9.37123 11.5691 7.3766 11.5691 5.4812C11.5691 2.48116 9.1037 0.418701 6.00039 0.418701C2.89708 0.418701 0.431641 2.48116 0.431641 5.4812C0.431641 7.3847 1.38947 9.37933 2.96188 11.1644C4.14043 12.5029 5.6207 13.5812 6.00039 13.5812ZM6.00039 8.9237C5.14109 8.9237 4.31698 8.58235 3.70936 7.97473C3.10175 7.36711 2.76039 6.543 2.76039 5.6837C2.76039 4.8244 3.10175 4.00029 3.70936 3.39268C4.31698 2.78506 5.14109 2.4437 6.00039 2.4437C6.85969 2.4437 7.6838 2.78506 8.29142 3.39268C8.89903 4.00029 9.24039 4.8244 9.24039 5.6837C9.24039 6.543 8.89903 7.36711 8.29142 7.97473C7.6838 8.58235 6.85969 8.9237 6.00039 8.9237Z" fill="black"></path>' + 
'          </svg>' + 
'          <span class="font-lg-13 font-sm-13 gotham-medium">'+location+'</span></div>' + 
'                       <div class="d-flex align-items-center contact-icon">' + 
'          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.35007 15.6425C3.98471 15.6425 3.67183 15.5125 3.41142 15.2526C3.15146 14.9922 3.02148 14.6793 3.02148 14.3139V5.01385C3.02148 4.64849 3.15146 4.33583 3.41142 4.07587C3.67183 3.81547 3.98471 3.68527 4.35007 3.68527H5.01436V2.35669H6.34294V3.68527H11.6573V2.35669H12.9859V3.68527H13.6501C14.0155 3.68527 14.3284 3.81547 14.5888 4.07587C14.8487 4.33583 14.9787 4.64849 14.9787 5.01385V14.3139C14.9787 14.6793 14.8487 14.9922 14.5888 15.2526C14.3284 15.5125 14.0155 15.6425 13.6501 15.6425H4.35007ZM4.35007 14.3139H13.6501V7.67102H4.35007V14.3139ZM6.34203 13.0078C6.15381 13.0078 5.99593 12.944 5.86839 12.8165C5.74129 12.6894 5.67773 12.5317 5.67773 12.3435C5.67773 12.1553 5.74129 11.9974 5.86839 11.8699C5.99593 11.7427 6.15381 11.6792 6.34203 11.6792C6.53024 11.6792 6.68812 11.7427 6.81567 11.8699C6.94277 11.9974 7.00632 12.1553 7.00632 12.3435C7.00632 12.5317 6.94277 12.6894 6.81567 12.8165C6.68812 12.944 6.53024 13.0078 6.34203 13.0078ZM8.99919 13.0078C8.81097 13.0078 8.65332 12.944 8.52621 12.8165C8.39867 12.6894 8.3349 12.5317 8.3349 12.3435C8.3349 12.1553 8.39867 11.9974 8.52621 11.8699C8.65332 11.7427 8.81097 11.6792 8.99919 11.6792C9.18741 11.6792 9.34529 11.7427 9.47283 11.8699C9.59993 11.9974 9.66348 12.1553 9.66348 12.3435C9.66348 12.5317 9.59993 12.6894 9.47283 12.8165C9.34529 12.944 9.18741 13.0078 8.99919 13.0078ZM11.6564 13.0078C11.4681 13.0078 11.3105 12.944 11.1834 12.8165C11.0558 12.6894 10.9921 12.5317 10.9921 12.3435C10.9921 12.1553 11.0558 11.9974 11.1834 11.8699C11.3105 11.7427 11.4681 11.6792 11.6564 11.6792C11.8446 11.6792 12.0022 11.7427 12.1293 11.8699C12.2569 11.9974 12.3206 12.1553 12.3206 12.3435C12.3206 12.5317 12.2569 12.6894 12.1293 12.8165C12.0022 12.944 11.8446 13.0078 11.6564 13.0078ZM5.86839 10.137C5.99593 10.2646 6.15381 10.3283 6.34203 10.3283C6.53024 10.3283 6.68812 10.2646 6.81567 10.137C6.94277 10.0099 7.00632 9.85226 7.00632 9.66405C7.00632 9.47583 6.94277 9.31795 6.81567 9.19041C6.68812 9.06331 6.53024 8.99976 6.34203 8.99976C6.15381 8.99976 5.99593 9.06331 5.86839 9.19041C5.74129 9.31795 5.67773 9.47583 5.67773 9.66405C5.67773 9.85226 5.74129 10.0099 5.86839 10.137ZM8.52621 10.137C8.65332 10.2646 8.81097 10.3283 8.99919 10.3283C9.18741 10.3283 9.34529 10.2646 9.47283 10.137C9.59993 10.0099 9.66348 9.85226 9.66348 9.66405C9.66348 9.47583 9.59993 9.31795 9.47283 9.19041C9.34529 9.06331 9.18741 8.99976 8.99919 8.99976C8.81097 8.99976 8.65332 9.06331 8.52621 9.19041C8.39867 9.31795 8.3349 9.47583 8.3349 9.66405C8.3349 9.85226 8.39867 10.0099 8.52621 10.137ZM11.1834 10.137C11.3105 10.2646 11.4681 10.3283 11.6564 10.3283C11.8446 10.3283 12.0022 10.2646 12.1293 10.137C12.2569 10.0099 12.3206 9.85226 12.3206 9.66405C12.3206 9.47583 12.2569 9.31795 12.1293 9.19041C12.0022 9.06331 11.8446 8.99976 11.6564 8.99976C11.4681 8.99976 11.3105 9.06331 11.1834 9.19041C11.0558 9.31795 10.9921 9.47583 10.9921 9.66405C10.9921 9.85226 11.0558 10.0099 11.1834 10.137Z" fill="black"></path>' + 
'          </svg>' + 
'          <span class=" font-lg-13 font-sm-13 gotham-medium">'+eventStartMonth+' '+eventStartDate+' - '+eventEndMonth+' '+eventEndDate+'</span></div>' + 
'                       <div class="d-flex align-items-center contact-icon">' + 
'          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' + 
'          <path d="M6.68068 10.0835C7.26379 10.8023 7.80656 11.4698 8.364 12.1519C8.64272 11.6825 8.64638 11.6128 8.47768 10.5309H9.42386V12.0895C9.48988 12.1152 9.55589 12.1372 9.6219 12.1629C10.1097 11.5578 10.6194 10.9673 11.0705 10.3365C11.2282 10.1202 11.3492 10.0505 11.5949 10.1055C11.7783 10.1458 11.9727 10.1422 12.1634 10.1458C13.3039 10.1788 14.0924 10.729 14.5912 11.7448C15.376 13.3474 15.0679 14.0809 13.3443 14.5687C11.7453 15.0198 10.0987 15.1078 8.45935 15.0234C7.1611 14.9537 5.85186 14.8181 4.59029 14.532C2.95464 14.1616 2.65392 13.3731 3.35439 11.8475C3.85681 10.7546 4.6783 10.1642 5.89587 10.1385C6.17458 10.1312 6.44964 10.0982 6.68435 10.0835H6.68068Z" fill="black"></path>' + 
'          <path d="M8.99523 2.25C10.8802 2.25 12.0318 3.39055 12.0685 5.27924C12.0721 5.47361 12.1418 5.66798 12.1932 5.85868C12.3399 6.37944 12.2628 6.87454 11.9951 7.33662C11.8448 7.60067 11.6981 7.86839 11.5184 8.11044C11.1663 8.59086 10.8546 9.12263 10.4218 9.5187C9.53433 10.3402 8.4928 10.3219 7.56862 9.53337C7.31558 9.317 7.0772 9.06395 6.89383 8.7889C6.54543 8.2718 6.20437 7.7437 5.92565 7.18626C5.69827 6.72418 5.60292 6.22908 5.8743 5.71199C5.97332 5.52128 5.92565 5.25723 5.94398 5.02619C6.11268 3.24385 7.20556 2.25 8.99523 2.25ZM8.99523 9.65439C9.36196 9.49303 9.76537 9.42335 9.99641 9.18864C10.4365 8.73756 10.7776 8.18745 11.159 7.67769C11.2433 7.56767 11.2947 7.42464 11.401 7.34029C11.8154 6.99923 11.8521 6.46379 11.4744 6.05672C11.4267 6.00537 11.412 5.92836 11.3863 5.86235C11.137 5.23156 10.4622 4.91984 9.76537 4.99685C9.20793 5.05553 8.62482 5.04453 8.07105 4.95284C7.34125 4.83182 6.97818 4.96384 6.68112 5.64964C6.62245 5.78167 6.59677 5.94303 6.50876 6.04571C6.20437 6.39778 6.17869 6.90754 6.45008 7.23761C6.63711 7.46498 6.78381 7.7217 6.96351 7.95641C7.28257 8.37082 7.57229 8.81824 7.95736 9.16297C8.22141 9.40135 8.62116 9.4857 8.99523 9.65439Z" fill="black"></path>' + 
'          </svg>' + 
'          <span class="font-lg-13 font-sm-13 gotham-medium">'+gender+'</span></div>' + 
'          <div class="d-flex justify-content-center align-items-center mt-4">' + 
             (formattedRegEndDate < formattedCurrentDate ? '' : 
'              <a href="https://app.utrsports.net/events/'+id+'" target="_blank" class="btn-black-sm btn-outline-black justify-content-center text-center min-w-160 btn-xs-1 min-w-sm-145 font-lg-16 font-sm-14 text-uppercase">Register</a> ' 
           )+ 
'          </div>' + 
'           </div>' + 
'        </div>' + 
'      </div>';  

          //Increment the count
          i=i+1;  
        
        }

        

      });

      if (!addToGrid) {
        grid_element.innerHTML = '<h3 class="text-uppercase gotham-medium fst-italic font-sm-12 min-w-lg-180 min-w-sm-160 mb-0" style="color: #fff;">No events found that match your search.</h3>';
      } else {
        if (i > 6) {
          loadMoreBtn.style.display = "inline-block";
        } else {
          loadMoreBtn.style.display = "none";
        }
        grid_element.innerHTML = data;
      }
    })
    .catch(error => console.log('error', error));    
  }

  //Helper functions
  var getDaysInMonth = function(month,year) {
    // Here January is 1 based
    //Day 0 is the last day in the previous month
   return new Date(year, month, 0).getDate();
  // Here January is 0 based
  // return new Date(year, month+1, 0).getDate();
  };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-ranking-section"] && !Shopify.designMode) return;
  try {
    
  
  var requestOptions = {
  method: 'GET',
  redirect: 'follow',
  };
// fetch("https://api.universaltennis.com/v3/player/searchlimits", requestOptions)
//   .then(response => response.json())
//   .then((result) => {
//     let data="";
//     result.map((values)=>{
//           data +='<div class="pro-tennis text-center"><div class="pro-tennis-img"><img src="https://cdn.shopify.com/s/files/1/0690/8071/1488/files/asset-6-2.png?v=1672728751"></div><p>'+values.name+'</p></div> ';      
//     });
//     document.getElementById("cat").innerHTML=data;
//   })
//   .catch(error => console.log('error', error));

  // fetch("https://api.universaltennis.com/v3/player/top?gender=M&count=100", requestOptions)
  // fetch("https://api.universaltennis.com/v3/player/top?gender=F&count=100", requestOptions)
  // .then(response => response.json())
  
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("filter_input");
  filter = input.value;
  
  Promise.all([
  fetch("https://api.universaltennis.com/v3/player/top?gender=M&count=100", requestOptions),
  fetch("https://api.universaltennis.com/v3/player/top?gender=F&count=100", requestOptions)
  ]).then(function (responses) {
  	return Promise.all(responses.map(function (response) {
		return response.json();
	}));
  }) .then(function (result){
    let data="";
    console.log(result[0].concat(result[1]))
    result[0].concat(result[1]).map((values)=>{
      if(values.threeMonthRating != null){
        threeMonthRating = values.threeMonthRating;
      }else{
        threeMonthRating = '--';
      }

        if(values.gender == 'Female'){
        var style = 'none';
      }
          data +='<tr style="display:'+style+'"><td>'+values.utrRanking+'</td><td class="fw-bold d-flex gap-1 align-items-center text-sm-left">'+values.firstName+' '+values.lastName+'</td><td class="fw-bold text-left d-sm-none d-md-none">'+values.gender+'</td><td class="text-center d-sm-none d-md-none">'+values.nationality+'</td><td class="text-center d-sm-none d-md-none">'+threeMonthRating+'</td><td class="text-center">'+values.utr+'</td></tr>';
  }); 
    
    document.getElementById("table").innerHTML=data;
  }) 
  .catch(error => console.log('error', error));
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-ranking"] && !Shopify.designMode) return;
  try {
    
    var currentUrl = window.location.href;
    var filterURL = "https://api.utrsports.net/v3/player/top?";

    var filterParam = "&count=100";
    var genderParam = "gender=m";
  
    var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    };

    var input = document.getElementById("filter_input");
  var inputValue =  $("#filter_input").val();
  var urlParam;
  var urlGender;   
    
    $('input[type=radio][name="ut-rank-filter-radio"]').change(function() {
        //Default URL
        filterURL = "https://api.utrsports.net/v3/player/top?";
        if($(this).val()=="U14") {
          filterParam = "&tags=U14&count=25";
          urlParam = "u14";
        } else if($(this).val()=="U16") {
          filterParam = "&tags=U16&count=25";
          urlParam = "u16";
        } else if($(this).val()=="U18") {
          filterParam = "&tags=U18&count=25";
          urlParam="u18";
        } else if($(this).val()=="HighSchool") {
          filterParam = "&tags=HighSchool&count=25";
          urlParam = "high-school";
        } else if($(this).val()=="College") {
          filterParam = "&tags=College&count=25";
          urlParam = "college";
        } else if($(this).val()=="Pro") {
          filterParam = "&tags=Pro&count=100";
          urlParam = "pro";
        }
          
          
        else  {
          //PTT by default
          //URL for PTT
          filterURL = "https://api.utrsports.net/pts/player/top?";
          filterParam = "&top=100&skip=0";
          urlParam = "ptt";
        }

      console.log("inputValue", inputValue);
      
 if (genderParam === 'gender=f') {
    urlGender = urlParam === "u14" || urlParam === "u16" || urlParam === "u18" ? "girls" : "women";
} else {
    urlGender = urlParam === "u14" || urlParam === "u16" || urlParam === "u18" ? "boys" : "men";
}      
      fetchRankings();
      generateAndUpdateUrl();
      
    });

   $("#filter_input").change(function () {
      if (this.value == "f") {
        genderParam = "gender=f";
        urlGender = urlParam === "u14" || urlParam === "u16" || urlParam === "u18" ? "girls" : "women";
      } else {
        genderParam = "gender=m";
        urlGender = urlParam === "u14" || urlParam === "u16" || urlParam === "u18" ? "boys" : "men";
      }
      fetchRankings();
     generateAndUpdateUrl();
    });

////////
   // Display the current URL
  // console.log("Current URL:", currentUrl);

    // Split the URL based on '/'
  var urlParts = currentUrl.split('/');
  // Get the last part of the URL
  var lastPart = urlParts[urlParts.length - 1];

// console.log("urlParts lastPart", lastPart);
  // Check if the URL contains specific substrings
  var hasU14 = lastPart.includes("u14");
  var hasU16 = lastPart.includes("u16");
  var hasU18 = lastPart.includes("u18");
  var hasHighSchool = lastPart.includes("high-school");
  var hasCollege = lastPart.includes("college");
  var hasPro = lastPart.includes("pro");
  var hasPtt = lastPart.includes("ptt");
  var hasBoysOrMen = lastPart.includes("boys") || lastPart.includes("men");
  var hasGirlsOrWomen = lastPart.includes("girls") || lastPart.includes("women");
  var selectedGender

  // Display the results
  // console.log("has hasU14", hasU14);
  // console.log("has hasU16", hasU16);
  // console.log("has hasU18", hasU18);
  // console.log("has hasHighSchool", hasHighSchool);
  // console.log("has hasCollege", hasCollege);
  // console.log("has hasPro", hasPro);
  // console.log("has hasPtt", hasPtt);
  // console.log("has hasBoysOrMen", hasBoysOrMen);
  // console.log("has hasGirlsOrWomen", hasGirlsOrWomen);

    // Determine the value based on conditions
  if (hasU14) {    
    // console.log("has hasU14", hasU14);
    filterParam = "&tags=U14&count=25";
    urlParam = "u14";
  } else if (hasU16) {
    // console.log("has hasU16", hasU16);
    filterParam = "&tags=U16&count=25";
    urlParam = "u16";
  } else if (hasU18) {
    // console.log("has hasU18", hasU18);
    filterParam = "&tags=U18&count=25";
    urlParam = "u18";
  } else if (hasHighSchool) {
    // console.log("has hasHighSchool", hasHighSchool);
    filterParam = "&tags=HighSchool&count=25";
    urlParam = "high-school";
  } else if (hasCollege) {
    // console.log("has hasCollege", hasCollege);
    filterParam = "&tags=College&count=25";
    urlParam = "college";
  } else if (hasPro) {
    // console.log("has hasPro", hasPro);
    filterParam = "&tags=Pro&count=100";
    urlParam = "pro";
  } 
  // else if (hasPtt) {
  //     filterURL = "https://api.utrsports.net/pts/player/top?";
  //         filterParam = "&top=100&skip=0";
  //   urlParam = "ptt";
  // } 
  else {    
    console.log("condition base value from url not applied");
  }
  if(hasGirlsOrWomen) {
    genderParam = "gender=f";
    selectedGender = "f";
  } else if (hasBoysOrMen) {
    genderParam = "gender=m";
    selectedGender = "m";
  } else {
    selectedGender = "m";
  }

   // console.log("genderParam đã cập nhật:", genderParam);

if (hasPtt) {
    filterURL = "https://api.utrsports.net/pts/player/top?";

    // console.log("genderParam set skip:", genderParam);

    if (genderParam.trim() === "gender=f") {
        filterParam = "&top=100&skip=199";
    } else {
        filterParam = "&top=100&skip=200";
    }
    
    urlParam = "ptt";
}
  
  // console.log("filterParam and genderParam", filterParam, ' and ', genderParam);  

fetchRankings();





  // Set the value of the radio buttons based on conditions
$('input[type=radio][name="ut-rank-filter-radio"]').each(function () {
  var value = $(this).val();
  
  if ((value === "U14" && hasU14) ||
      (value === "U16" && hasU16) ||
      (value === "U18" && hasU18) ||
      (value === "HighSchool" && hasHighSchool) ||
      (value === "College" && hasCollege) ||
      (value === "Pro" && hasPro) ||
      (value === "Ptt" && hasPtt)) {
    // If the condition is met, set the 'checked' property
    $(this).prop('checked', true);
  }
});
  // Set the selected option of the <select> element based on conditions
$('#filter_input').val(selectedGender);
////////

  function generateAndUpdateUrl (){
    // console.log("generateAndUpdateUrl");
    var fullUrl = `${urlParam ? urlParam + '-' : ''}utr-${urlGender}-tennis-rankings`;
    // console.log("the made in url", fullUrl);


// Get the current URL
var currentUrl = window.location.href;

// Find the index of '/pages'
var pagesIndex = currentUrl.indexOf('/pages');

if (pagesIndex !== -1) {
    // Get the substring from the beginning up to '/pages' + 6 (length of '/pages')
    var baseUrl = currentUrl.substring(0, pagesIndex + 6);

    // Construct the new URL by appending fullUrl to the baseUrl
    var newUrl = baseUrl + '/' + fullUrl;

    // Redirect to the new URL
    window.location.href = newUrl;
}
  }

    var getCountry = async function (nationality) {
        const response = await fetch('https://cdn.shopify.com/s/files/1/0690/8071/1488/files/new_flags_iso.csv?v=1733814604');
        const text = await response.text();
        const rows = text.split('\n');
        const headers = rows[0].split(',').map(header => header.trim());
    
        const countryCodeColumnIndex = headers.indexOf('Alpha-3 code');
        const countryNameColumnIndex = headers.indexOf('Country');
        const flagUrlColumnIndex = headers.indexOf('URL');
    
        let countryInfo = { flagImageUrl: '', countryName: '' };
        var flag = '';
    
        rows.slice(1).forEach(row => {
            const columns = row.split(',');
            if (columns[countryCodeColumnIndex] === nationality) {
                countryInfo.countryName = columns[countryNameColumnIndex];
                countryInfo.flagImageUrl = columns[flagUrlColumnIndex];
                flag += '<img src="'+countryInfo.flagImageUrl+'" alt="'+nationality+'" title="'+countryInfo.countryName+'" style="width: 32px; height: 24px; margin-right: 5px;">';
            }
        });  
        return countryInfo;
      }
 
    function fetchRankings (){
      var fetchURL = filterURL+genderParam+filterParam;
      Promise.all([
        fetch(fetchURL, requestOptions),
      ]).then(function (responses) {
        return Promise.all(responses.map(function (response) {
          return response.json();
        }));
      }).then(function (result){
        let data="";
        result[0].map((values)=>{
          let threeMonthRating;
          let rankingsSNo;
          if(values.threeMonthRating != null){
            threeMonthRating = values.threeMonthRating;
          }else{
            threeMonthRating = '--';
          }
          if (filterURL.includes("pts")) {
            for (let itr = 0; itr < values.rankings.length; itr++) {
              if (genderParam == "gender=f") {
                //Female PTT rank id is 51
                if (values.rankings[itr].rankListId == '51') {
                  rankingsSNo = values.rankings[itr].rank;
                  break;
                }
              } else {
                //Male PTT rank id is 52
                if (values.rankings[itr].rankListId == '52') {
                  // console.log("Male52 values.rankings = ",values.rankings[itr].rank);
                  rankingsSNo = values.rankings[itr].rank;
                  break;
                }
              }
            }
          } else {
            rankingsSNo = values.utrRanking;
          }

          const nationality = values.nationality;
          getCountry(values.nationality).then((value) => {
            const flagMap = {
              GER: 'de',
              VIE: 'vn',
              PHI: 'ph',
              CRO: 'hr',
              SLO: 'si',
              LAT: 'lv',
              TPE: 'tw',
              GRE: 'gr',
              NED: 'nl',
              NGR: 'ng',
              RSA: 'za',
              SUI: 'ch',
              CHE: 'ch',
              BUL: 'bg',
              DEN: 'dk',
              CHI: 'cl',
              POR: 'pt',
              ES: 'es',
              HKG: 'hk',
              INA: 'id',
              BAH: 'bs',
              PAR: 'py',
              NMI: 'mp',
              UKR: 'ua'
            };

            const code = String(nationality || '').trim().toUpperCase();
            const iso2 = flagMap[code];

            const rawFlagUrl = iso2
              ? `https://flagcdn.com/w80/${iso2}.png`
              : value.flagImageUrl;

            const flagUrl = String(rawFlagUrl || '')
              .replace(/\/\/img/g, '/img')
              .replace(/\s+/g, '')
              .trim();

            $('.flag-' + code + ' img')
              .attr('src', flagUrl)
              .attr('title', value.countryName || code);
          }).catch((error) => {
            console.error('Error loading country flag:', nationality, error);
          });

          const flagHTML = (nationality === 'RUS' || nationality === 'BLR')
          ? `<span></span><img src="" alt="${nationality}" title="" style="width: 32px; height: 24px; margin-right: 5px;">`
          : `<img src="" alt="${nationality}" title="" style="width: 32px; height: 24px; margin-right: 5px;">`;

          var threeMonthFloatValue = parseFloat(threeMonthRating).toFixed(2);
          data +='<tr style=""><td>'+  rankingsSNo  +'</td><td class="fw-bold d-flex gap-1 align-items-center text-left hover-black "><a href="https://app.universaltennis.com/profiles/'+values.id+'" class="" target="_blank">'+values.firstName+' '+values.lastName+'</a></td><td class="fw-bold text-left hidden-desktop">'+values.gender+'</td><td class="flag-'+values.nationality+' text-center hidden-desktop">'+ flagHTML +'</td><td class="text-center hidden-desktop">'+(isNaN(threeMonthFloatValue)?"-":threeMonthFloatValue)+'</td><td class="text-center">'+(filterURL.includes("pts") ? parseFloat(values.singlesUtrDisplay).toFixed(2) : parseFloat(values.utr).toFixed(2))+'</td></tr>';
        });
        document.getElementById("rtable").innerHTML=data;
    })
    .catch(error => console.log('error', error));
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ut-team-tennis-leagues"] && !Shopify.designMode) return;
  try {
    
  
    // Access the value of team_tennis_league_type
  var teamTennisLeagueType = document.getElementById('teamTennisLeagueType').innerText;
  

  // Now you can use the value in your JavaScript logic
  console.log('Team Tennis League Type:', teamTennisLeagueType);

  let leagueTypeValue = '1';

   // Example: Condition based on the league type
  if (teamTennisLeagueType === '1') {
    // for adult team tennis
    leagueTypeValue = teamTennisLeagueType
    
  } else if (teamTennisLeagueType === '3') {
    // for junior team tennis
    leagueTypeValue = teamTennisLeagueType;
    
  } else if (teamTennisLeagueType === '6') {
    // for adult team pickleball
    leagueTypeValue = teamTennisLeagueType;
    
  } else if (teamTennisLeagueType === '7') {
    // for junior team pickleball
    leagueTypeValue = teamTennisLeagueType;
    
  } 


  let markerLocations = [];
  let eventLocations = [];
  let map;

   let elseCounter = 0;
  
  function setMarkers() {
    
    var infoWindow;
    
    for (var i = 0; i < eventLocations.length; i++) {
      var event = eventLocations[i];
      var myLatLng = new google.maps.LatLng(event[0], event[1]);
      const pinIcon = "https://cdn.shopify.com/s/files/1/0690/8071/1488/files/location-vector.svg?v=1679692179";
      // Create an info window to share between markers.
      infoWindow = new google.maps.InfoWindow();
      
      var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          icon: pinIcon,
          animation: google.maps.Animation.DROP,
          title: event[2],
          zIndex: event[3],
          optimized: true
      });

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          var contentString = '<div><a href="https://leagues.utrsports.net/leagues/session/'+eventLocations[i][4]+'" target="_blank">'+marker.getTitle()+'</div>';
          infoWindow.close();
          infoWindow.setContent(contentString);
          infoWindow.open(map, marker);
          for(var j = 0; j < markerLocations.length; j++) {
            //markerLocations[j].
          }
        }
    
      })(marker, i)); 
      
      // Push marker to markers array
      markerLocations.push(marker);
      
      map.setZoom(4);
      map.panTo(marker.position);

    }
    
  }

  function reloadMarkers() {

    // Loop through markers and set map to null for each
    for (var i=0; i<markerLocations.length; i++) {

        markerLocations[i].setMap(null);
        markerLocations[i] = null;
    }

    // Reset the markers array   
    markerLocations = [];

    // Call set markers to re-add markers
    setMarkers();
    
    

  }

  window.initializeMap = function(){
    var mapOptions = {
       zoom: 4,
       center: { lat: 34.84555, lng: -101.299591 }
    }

    map = new google.maps.Map(document.getElementById('map'), mapOptions);
    
    setMarkers();

    // Bind event listener on button to reload markers
    //document.getElementById('reloadMarkers').addEventListener('click', reloadMarkers);

  }

  var clubData = {
    clubIds: []
  };

  var searchText = "";
  var distanceText = "";
  
  //Search Functionality
  let searchBtn = document.querySelector('.club-search-btn');
  searchBtn.onclick = () => {
    searchText = document.getElementById('search_input').value;
    distanceText = document.getElementById('distance_input').value;
    fetchDataFromGoogleMapAPI(searchText);
  }

  $('#search_input').keypress(function (e) {
    if (e.which == 13) {
      e.preventDefault();
      //do something
      searchText = document.getElementById('search_input').value;
      distanceText = document.getElementById('distance_input').value;
      fetchDataFromGoogleMapAPI(searchText);
       elseCounter = 0;
   }
  });

  function formatEventDate(dateString) {
  const options = { month: 'long', day: 'numeric' };
  const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
  return formattedDate;
}
  

  //Fetch initial club data
  var latVal = 34.84555;
    var longVal = -101.299591;
  fetchClubs(latVal, longVal);
 
   var distence_msg = document.getElementById("updating-msg");

  
function fetchClubs(latVal, longVal) {
    eventLocations = [];
  if(searchText == ''){
  distanceText = '';
}

    // console.log("the fetch data values", latVal, longVal, distanceText, searchText);

    const distanceData = distanceText ? distanceText : 100000;
    var requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            pagination: {
                take: 50
            },
            searchProperties: {
                distance: distanceData,
                lat: latVal,
                long: longVal,
                leagueTypeId: leagueTypeValue
            }
        })
    };
    var cCount = 0;

    fetch('https://search-api.utrsports.net/v3/search/leagues/sessions/bylocation', requestOptions)
        .then(response => response.json())
        .then((result) => {
            let data = "";
             // let responseData = result.documents
             // console.log("the response data", responseData);
          // Get the current date
            const today = new Date();

            // Filter data based on startDateUtc
            let responseData = result.documents.filter(values => {
                const startDate = new Date(values.startDateUtc);
                // Compare with today's date
                return startDate > today;
            });
 console.log("responseData Data:", responseData);
          
            if (responseData.length > 0) {
                responseData.forEach((values) => {

                    var id = values.id;
                    var member = values.memberCount;
                    var eventStartDate = values.startDateUtc;
                    var eventEndDate = values.endDateUtc;
                    var eventLookingFor = values.sessionLookingForTeams;
                    var llat = values.location.latLng[0];
                    var llng = values.location.latLng[1];
                    var eventStartEndDate = formatEventDate(eventStartDate) + ' - ' + formatEventDate(eventEndDate);
                    var registrationEndDate = formatEventDate(values.teamRegistrationEndDateUtc);
                    var totalTeams = values.maxTeamsInSession;
                    var profileUrl = values.profileUrl

                    data += `
                        <div class="item">
                          <div class="search-item-data pe-lg-6 border-radius-lg-18 border-radius-sm-3 text-black p-2 position-relative">
                            <div class="d-flex align-items-center justify-content-between">
                              <h3 class="mb-2 flex-text-ellipsis mt-0 fw-bold text-uppercase lh-normal cutom_title">${values.name}</h3>
                            </div>
                            <div class="d-flex align-items-center justify-content-start flex-sm-column align-items-sm-start justify-content-sm-start">
                              <h4 class="d-flex align-items-lg-center justify-content-lg-center gap-1 mb-0 mt-0">
                                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M3.26133 4.24336C3.26133 3.36814 3.60901 2.52878 4.22788 1.90991C4.84675 1.29104 5.68611 0.943359 6.56133 0.943359C7.43654 0.943359 8.27591 1.29104 8.89478 1.90991C9.51365 2.52878 9.86133 3.36814 9.86133 4.24336C9.86133 5.11857 9.51365 5.95794 8.89478 6.57681C8.27591 7.19568 7.43654 7.54336 6.56133 7.54336C5.68611 7.54336 4.84675 7.19568 4.22788 6.57681C3.60901 5.95794 3.26133 5.11857 3.26133 4.24336ZM11.0613 6.04336C11.0613 5.68879 11.1312 5.33769 11.2669 5.01011C11.4025 4.68253 11.6014 4.38489 11.8521 4.13417C12.1029 3.88345 12.4005 3.68457 12.7281 3.54888C13.0557 3.4132 13.4068 3.34336 13.7613 3.34336C14.1159 3.34336 14.467 3.4132 14.7946 3.54888C15.1222 3.68457 15.4198 3.88345 15.6705 4.13417C15.9212 4.38489 16.1201 4.68253 16.2558 5.01011C16.3915 5.33769 16.4613 5.68879 16.4613 6.04336C16.4613 6.75944 16.1769 7.4462 15.6705 7.95255C15.1642 8.4589 14.4774 8.74336 13.7613 8.74336C13.0452 8.74336 12.3585 8.4589 11.8521 7.95255C11.3458 7.4462 11.0613 6.75944 11.0613 6.04336ZM0.861328 14.4434C0.861328 12.9316 1.46186 11.4818 2.53082 10.4129C3.59978 9.34389 5.04959 8.74336 6.56133 8.74336C8.07306 8.74336 9.52288 9.34389 10.5918 10.4129C11.6608 11.4818 12.2613 12.9316 12.2613 14.4434V14.4458L12.2605 14.541C12.2588 14.6427 12.2313 14.7423 12.1805 14.8305C12.1297 14.9187 12.0573 14.9925 11.9701 15.045C10.3375 16.0281 8.46714 16.5463 6.56133 16.5434C4.58373 16.5434 2.73253 15.9962 1.15333 15.045C1.06601 14.9926 0.993462 14.9188 0.942517 14.8306C0.891573 14.7425 0.863908 14.6428 0.862128 14.541L0.861328 14.4434ZM13.4613 14.4458L13.4605 14.561C13.4561 14.8276 13.3924 15.0899 13.2741 15.329C14.6707 15.4151 16.0657 15.1367 17.3221 14.521C17.4193 14.4735 17.5018 14.4006 17.561 14.31C17.6201 14.2195 17.6537 14.1146 17.6581 14.0066C17.6864 13.3356 17.5408 12.6686 17.2357 12.0704C16.9305 11.4721 16.476 10.9628 15.9162 10.5918C15.3564 10.2207 14.7102 10.0005 14.0403 9.95254C13.3705 9.90454 12.6995 10.0303 12.0925 10.3178C12.9831 11.5086 13.4631 12.9563 13.4605 14.4434V14.4458H13.4613Z"
                                    fill="black"></path>
                                </svg>
                                <span class="fw-bold font-lg-18">${totalTeams}</span>
                              </h4>
                              <div id="flexEventStartDate_${id}">
                                <p class="font-lg-14 font-sm-12 mb-0 mt-0 d-sm-block ps-1">${eventStartEndDate}</p>
                              </div>
                            </div>
                            <div id="flexEventName_${id}">
                              <p class="font-lg-14 font-sm-12 mb-0 pb-sm-4"><span class="text-decoration-underline d-sm-block"> Team
                                  Registration Ends: ${registrationEndDate} </span></p>
                            </div>
                            <div class="rwbtn-lg mt-sm-0 d-sm-flex justify-content-sm-end">
                              ${eventLookingFor ?
                              `<div class="d-flex flex-column">
                                <a target="_blank" href="${profileUrl}"
                                  class="btn-black-sm btn-outline-black text-uppercase font-sm-14">REGISTER NOW</a>
                                  
                                <a target="_blank" href="https://www.utrsports.net/pages/team-captains"
                                  class="btn-black-sm mt-1 btn-outline-black text-uppercase font-sm-14" style="display: none">Captain a Team</a>
                                  
                              </div>` : ''}
                            </div>
                          </div>
                        </div>`;
                  
                    eventLocations.push([llat, llng, values.name, cCount, id]); // Use club name from 'values'
                    cCount += 1;
                    elseCounter = 0;
                });
                if (elseCounter == 0) {
                    distence_msg.innerHTML = ' ';
                }
                map.setZoom(6);
            } else {
              if(searchText !== ''){
                elseCounter++;
                // console.log("searchText is not empty");
              }
                // console.log("elseCounter", elseCounter);
                if (elseCounter == 0) {
                    distence_msg.innerHTML = '';
                }
                if (elseCounter <= 1) {
                    var searchText = document.getElementById('search_input').value;
                    var setinInputBox = document.getElementById('distance_input');
                    setinInputBox.value = '250';
                    distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + distanceText + ' miles - displaying results within 250 miles</h3>';

                    distanceText = '250';
                    setTimeout(function () {
                        fetchDataFromGoogleMapAPI(searchText);
                    }, 1000);
                } else if (elseCounter <= 2) {

                    var searchText = document.getElementById('search_input').value;
                    var setinInputBox = document.getElementById('distance_input');
                    setinInputBox.value = '500';
                    distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + distanceText + ' miles - displaying results within 500 miles</h3>';
                    distanceText = '500';

                    setTimeout(function () {
                        fetchDataFromGoogleMapAPI(searchText);
                    }, 1000);
                } else {
                    var setinInputBox = document.getElementById('distance_input');
                    distence_msg.innerHTML = '<h3 class="flex-text-ellipsis mt-0 mb-1 fw-bold lh-normal">No results within ' + setinInputBox.value + ' miles </h3>';
                    elseCounter = 0;
                    distanceText = '100';
                }
            }
            var element_flex = document.getElementById("flex");
            if (element_flex) {
                element_flex.innerHTML = data;
            }

            reloadMarkers();

        }).catch(error => console.log('error', error));
}

function fetchDataFromGoogleMapAPI(region){
  // console.log("fetchDataFromGoogleMapAPI");
    if (!region) {
       var latVal = 39.753657;
    var longVal = -100.635920;
  if (latVal && longVal) {
             fetchClubs(latVal, longVal);
          }
    } else {
          const fetchURL = 'https://maps.googleapis.com/maps/api/geocode/json?address='+region+'&key=AIzaSyCapzh9VsfXAzC9fAaosZJulONx7H1BFaY&language=en';
    let latVal = "";
    let longVal = "";
    
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };  
    fetch(fetchURL, requestOptions)
      .then(response => response.text())
      .then((data) => {
        let result = JSON.parse(data);
       console.log("result g map", result)
        if (result.results.length > 0) {
          latVal = result.results[0].geometry.location.lat;
          longVal = result.results[0].geometry.location.lng;
          // console.log("lat and long values google fetch" ,'latVal ', latVal, ' longVal ',  longVal, 'region', region)
          if (latVal && longVal) {
             fetchClubs(latVal, longVal);
          }
        }
      })
      .catch(error => console.log('error', error));      
    }    
  }

  } catch(e) { console.error(e); }
})();
})();
